import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import '../styles/Contabilidade.css';

// Imports do Recharts para ambos os gráficos
import { 
  PieChart, 
  Pie, 
  Cell, 
  Tooltip, 
  Legend, 
  ResponsiveContainer,BarChart ,
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid,
  Tooltip as RechartsTooltip
} from 'recharts'
import { notificar } from '../utils/notify';






// COMPONENTE DE NOTIFICAÇÃO DE ATRASO +10 DIAS
// COMPONENTE DE NOTIFICAÇÃO DE ATRASO +10 DIAS (ATUALIZADO)// COMPONENTE DE NOTIFICAÇÃO DE ATRASO +10 DIAS (OBRIGATÓRIO)
const NotificationAtraso10Dias = ({ username }) => {
  const [showModal, setShowModal] = useState(false);
  const [empresasAtraso, setEmpresasAtraso] = useState([]);
  const [carregando, setCarregando] = useState(false);

  // Buscar empresas com +10 dias de atraso SEM observação
  useEffect(() => {
    const verificarAtrasosGraves = async () => {
      console.log('[ATRASO] Iniciando verificação de empresas com +10 dias de atraso...');
      console.log('[ATRASO] Username atual:', username);
      
      if (!username || username === 'usuário') {
        console.log('[ATRASO] Username inválido, pulando verificação');
        return;
      }
      
      try {
        setCarregando(true);
        const accessToken = localStorage.getItem('access');
        
        console.log('[ATRASO] Chamando API /api/listar-empresas-atraso-10-dias/');
        
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/listar-empresas-atraso-10-dias/`,
          {
            params: { operador: username },
            headers: { Authorization: `Bearer ${accessToken}` }
          }
        );

        console.log('[ATRASO] Resposta da API:', response.data);

        if (response.data.success && response.data.empresas.length > 0) {
          console.log(`[ATRASO] Total de empresas encontradas: ${response.data.empresas.length}`);
          
          // FILTRAR APENAS EMPRESAS SEM OBSERVAÇÃO
          const empresasSemObservacao = response.data.empresas.filter(
            emp => !emp.observacao || emp.observacao.trim() === ''
          );

          console.log(`[ATRASO] Empresas SEM observação:`, empresasSemObservacao.length);

          if (empresasSemObservacao.length > 0) {
            console.log('[ATRASO] MOSTRANDO MODAL OBRIGATÓRIO - Empresas sem observação encontradas:', empresasSemObservacao);
            setEmpresasAtraso(empresasSemObservacao);
            setShowModal(true);
          } else {
            console.log('[ATRASO] Todas as empresas em atraso já possuem observação cadastrada');
          }
        } else {
          console.log('[ATRASO] Nenhuma empresa encontrada ou resposta vazia');
        }
        
        setCarregando(false);
      } catch (error) {
        console.error('[ATRASO] Erro ao verificar atrasos graves:', error);
        console.error('[ATRASO] Detalhes do erro:', error.response?.data);
        setCarregando(false);
      }
    };

    console.log('[ATRASO] useEffect executado - Username:', username);
    
    if (username && username !== 'usuário') {
      console.log('[ATRASO] Username válido, executando verificação...');
      verificarAtrasosGraves();
      
      // Verificar a cada 30 minutos
      const interval = setInterval(verificarAtrasosGraves, 1800000);
      return () => clearInterval(interval);
    } else {
      console.log('[ATRASO] Username inválido, pulando verificação');
    }
  }, [username]);

  const irParaAtrasos = () => {
    window.location.href = '/Atrasoatual';
  };

  if (!showModal) return null;

  return (
    <div 
      className="modal" 
      tabIndex="-1" 
      style={{
        display: 'block', 
        backgroundColor: 'rgba(0,0,0,0.85)', 
        zIndex: 9999,
        backdropFilter: 'blur(3px)'
      }}
      // PREVENIR FECHAMENTO AO CLICAR FORA
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div 
          className="modal-content shadow-lg border-danger border-3"
          // PREVENIR FECHAMENTO AO CLICAR NO MODAL
          onClick={(e) => e.stopPropagation()}
        >
          {/* REMOVIDO O BOTÃO X DE FECHAR */}
          <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
            <h5 className="modal-title mb-0 fw-bold w-100 text-center" style={{ color: '#212529' }}>
              <i className="fas fa-exclamation-triangle me-2 fa-beat"></i>
               AÇÃO OBRIGATÓRIA: Empresas com +10 dias de Atraso
            </h5>
          </div>
          
          <div className="modal-body">
            <div className="alert alert-danger border-start border-danger border-5 mb-4">
              <div className="d-flex align-items-center mb-3">
                <i className="fas fa-exclamation-circle fa-3x me-3 text-danger"></i>
                <div>
                  <h5 className="mb-1">
                    <strong>URGENTE!</strong> Empresas com atraso crítico detectadas
                  </h5>
                  <p className="mb-0">
                    <strong className="text-danger fs-4">{empresasAtraso.length}</strong> empresa(s) 
                    com mais de <strong className="text-danger">10 dias de atraso</strong> aguardando justificativa obrigatória.
                  </p>
                </div>
              </div>
              <hr className="my-2" />
              <p className="mb-0 text-center">
                <i className="fas fa-lock me-2"></i>
                <strong>Você precisa justificar esses atrasos antes de continuar.</strong>
              </p>
            </div>
            
            {/* Lista de empresas */}
            <div className="card mb-3 border-danger">
              <div className="card-header bg-danger text-white">
                <h6 className="mb-0">
                  <i className="fas fa-list me-2"></i>
                  Empresas que precisam de justificativa:
                </h6>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className="table table-hover mb-0">
                    <thead className="table-danger sticky-top">
                      <tr>
                        <th><i className="fas fa-building me-2"></i>Empresa</th>
                        <th><i className="fas fa-calendar-times me-2"></i>Próxima Entrega</th>
                        <th><i className="fas fa-clock me-2"></i>Dias Atraso</th>
                        <th><i className="fas fa-calendar-check me-2"></i>Competência</th>
                      </tr>
                    </thead>
                    <tbody>
                      {empresasAtraso.map((empresa, index) => (
                        <tr key={index} className="table-danger">
                          <td className="fw-bold">
                            <i className="fas fa-exclamation-triangle text-danger me-2"></i>
                            {empresa.empresa}
                          </td>
                          <td>{empresa.proxima_entrega}</td>
                          <td>
                            <span className="badge bg-danger fs-6">
                              <i className="fas fa-clock me-1"></i>
                              {empresa.dias_atraso} dias
                            </span>
                          </td>
                          <td>
                            <span className="badge bg-dark">
                              {empresa.competencia}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="alert alert-warning mb-0 border-3 border-warning">
              <div className="d-flex align-items-center">
                <i className="fas fa-info-circle fa-2x me-3 text-warning"></i>
                <div>
                  <strong>O que você precisa fazer:</strong>
                  <p className="mb-0 mt-1">
                    Clique no botão abaixo para acessar a página de gerenciamento e cadastrar as justificativas obrigatórias para cada empresa em atraso crítico.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* REMOVIDO O BOTÃO "FECHAR" - APENAS O BOTÃO DE AÇÃO */}
          <div className="modal-footer bg-light justify-content-center">
            <button 
              type="button" 
              className="btn btn-danger btn-lg shadow-lg px-5 py-3"
              onClick={irParaAtrasos}
              style={{
                fontSize: '1.1rem',
                fontWeight: 'bold',
                animation: 'pulse 2s infinite'
              }}
            >
              <i className="fas fa-exclamation-circle me-2"></i>
              Ir para Gerenciamento de Atrasos ({empresasAtraso.length})
              <i className="fas fa-arrow-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// COMPONENTE DE NOTIFICAÇÃO COM CADASTRO DIRETO
const NotificationModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [carregandoNotificacao, setCarregandoNotificacao] = useState(false);
  const [cadastrandoCliente, setCadastrandoCliente] = useState(false);
  const [mensagemCadastro, setMensagemCadastro] = useState('');

  // Ponte para toasts (react-toastify)
  useEffect(() => { notificar(mensagemCadastro); }, [mensagemCadastro]);

  // Estados para o formulário de cadastro
  const [showFormCadastro, setShowFormCadastro] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [dadosFormulario, setDadosFormulario] = useState({
    empresa: '',
    numero_dominio: '',
    operador: '',
    cnpj: '',
    email: ''
  });
  const [operadoresDisponiveis, setOperadoresDisponiveis] = useState([]);
  const [carregandoOperadores, setCarregandoOperadores] = useState(false);
  const [operadorFiltrado, setOperadorFiltrado] = useState('');



  // Buscar novos clientes do CustomerX (jornada 32 concluída) — UMA vez ao entrar.
  useEffect(() => {
    let cancelado = false;

    const fetchNovosClientes = async () => {
      try {
        setCarregandoNotificacao(true);
        const accessToken = localStorage.getItem('access');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/customerx-novos-clientes/`,
          {
            headers: { Authorization: `Bearer ${accessToken}` }
          }
        );

        if (cancelado) return;

        const clientes = response.data.newClients || [];
        if (clientes.length > 0) {
          setNotificationData(clientes);
          setShowModal(true);
        }
        setCarregandoNotificacao(false);
      } catch (error) {
        console.error('Erro ao buscar novos clientes do CustomerX:', error);
        setCarregandoNotificacao(false);
      }
    };

    fetchNovosClientes();
    return () => { cancelado = true; };
  }, []);
  
  // Buscar operadores disponíveis
  const buscarOperadores = useCallback(async () => {
    try {
      setCarregandoOperadores(true);
      setMensagemCadastro('');
      
      const accessToken = localStorage.getItem('access');
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/cadastrar-cliente-notion/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );
      
      if (response.data.success && Array.isArray(response.data.operadores)) {
        const operadoresOrdenados = response.data.operadores
          .filter(op => op && typeof op === 'string')
          .map(op => op.trim())
          .filter((op, index, array) => array.indexOf(op) === index)
          .sort();
        
        setOperadoresDisponiveis(operadoresOrdenados);
      } else {
        console.warn('Resposta inesperada da API:', response.data);
        setMensagemCadastro('Não foi possível carregar os operadores');
      }
      
      setCarregandoOperadores(false);
    } catch (error) {
      console.error('Erro ao buscar operadores:', error);
      setCarregandoOperadores(false);
      setMensagemCadastro(`Erro ao carregar operadores`);
    }
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setShowFormCadastro(false);
    setClienteSelecionado(null);
    setDadosFormulario({
      empresa: '',
      numero_dominio: '',
      operador: '',
      cnpj: '',
      email: ''
    });
    setMensagemCadastro('');
    setOperadorFiltrado('');
  };

  // Abrir formulário de cadastro
const abrirFormularioCadastro = async (cliente) => {
  setClienteSelecionado(cliente);
  setDadosFormulario({
    empresa: cliente.Empresa || '',
    numero_dominio: cliente['Nº Dominio'] || '', // CORRIGIDO: 'Nº Dominio' sem acento
    operador: '',
    cnpj: cliente.cnpj || '',
    email: cliente.email || ''
  });
  setOperadorFiltrado('');
  
  await buscarOperadores();
  setShowFormCadastro(true);
  setMensagemCadastro('');
};

  // Atualizar campos do formulário
  const handleInputChange = (campo, valor) => {
    setDadosFormulario(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  // Selecionar operador
  const selecionarOperador = (operador) => {
    setDadosFormulario(prev => ({
      ...prev,
      operador: operador
    }));
    setOperadorFiltrado('');
  };

  // Filtrar operadores
  const operadoresFiltrados = operadoresDisponiveis.filter(op =>
    op.toLowerCase().includes(operadorFiltrado.toLowerCase())
  );

  // Cadastrar cliente
  const cadastrarCliente = async () => {
    if (!dadosFormulario.empresa.trim()) {
      setMensagemCadastro('Nome da empresa é obrigatório');
      return;
    }
    
    if (!dadosFormulario.numero_dominio.trim()) {
      setMensagemCadastro('Número do Domínio é obrigatório');
      return;
    }
    
    if (!dadosFormulario.operador.trim()) {
      setMensagemCadastro('Operador é obrigatório');
      return;
    }

    try {
      setCadastrandoCliente(true);
      setMensagemCadastro('');
      
      const accessToken = localStorage.getItem('access');
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/cadastrar-cliente-notion/`,
        dadosFormulario,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );

        if (response.data.success) {
          setMensagemCadastro(`${response.data.mensagem}`);
          
          setNotificationData(prev => 
            prev.filter(c => c['Nº Dominio'] !== dadosFormulario.numero_dominio)
          );
          
          setTimeout(() => {
            setShowFormCadastro(false);
            setShowModal(false);
            setClienteSelecionado(null);
            setDadosFormulario({
              empresa: '',
              numero_dominio: '',
              operador: '',
              cnpj: '',
              email: ''
            });
            
            // REDIRECIONAR PARA EDIÇÃO DO CLIENTE RECÉM CADASTRADO
            localStorage.setItem('editar_cliente_notion', JSON.stringify({
              numero_dominio: dadosFormulario.numero_dominio,
              empresa: dadosFormulario.empresa
            }));
            window.location.href = '/Contabilidade';
          }, 2000);
        }
      
      setCadastrandoCliente(false);
    } catch (error) {
      console.error('Erro ao cadastrar cliente:', error);
      const errorMsg = error.response?.data?.mensagem || 'Erro ao cadastrar cliente';
      setMensagemCadastro(`${errorMsg}`);
      setCadastrandoCliente(false);
    }
  };

  if (!showModal) return null;

  return (
    <div 
      className="modal" 
      tabIndex="-1" 
      style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999}}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content shadow-lg">
          <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
            <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
              <i className="fas fa-bell me-2" style={{ color: '#212529' }}></i>
              Novos Clientes do CustomerX (Contabilidade)
            </h5>
            <button 
              type="button" 
              className="btn-close" 
              onClick={handleClose}
              disabled={cadastrandoCliente}
            ></button>
          </div>
          
          <div className="modal-body">
            {!showFormCadastro ? (
              <>
                <div className="alert alert-info border-start border-info border-3">
                  <i className="fas fa-info-circle me-2 text-info"></i>
                  <strong>Atenção!</strong> Você tem <strong className="text-danger">{notificationData.length}</strong> novo(s) cliente(s) com a jornada concluída no CustomerX para cadastro contábil.
                </div>
                
                <div className="table-responsive">
                  <table className="table table-striped table-hover align-middle">
                    <thead className="table-dark">
                      <tr>
                        <th>
                          <i className="fas fa-building me-2"></i>Empresa
                        </th>
                        <th>
                          <i className="fas fa-id-card me-2"></i>CNPJ / CPF
                        </th>
                        <th>
                          <i className="fas fa-barcode me-2"></i>Nº Domínio
                        </th>
                        <th>
                          <i className="fas fa-envelope me-2"></i>E-mail
                        </th>
                        <th>
                          <i className="fas fa-flag me-2"></i>Status
                        </th>
                        <th>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notificationData.map((cliente, index) => (
                        <tr key={index}>
                          <td className="fw-bold">{cliente.Empresa || 'Não definido'}</td>
                          <td>{cliente.cnpj || '-'}</td>
                          <td><code>{cliente['Nº Dominio'] || '-'}</code></td> {/* CORRIGIDO */}
                          <td>{cliente.email || '-'}</td>
                          <td>
                            <span 
                              className={`badge ${
                                cliente.Status === 'Em andamento' 
                                  ? 'bg-warning text-dark' 
                                  : 'bg-secondary'
                              }`}
                            >
                              {cliente.Status || 'Não definido'}
                            </span>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-primary"
                              onClick={() => abrirFormularioCadastro(cliente)}
                              disabled={carregandoOperadores}
                            >
                              <i className="fas fa-user-plus me-1"></i>
                              Cadastrar
                            </button>
                          </td>
                        </tr>

                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <>
                {/* FORMULÁRIO DE CADASTRO */}
                <div className="alert alert-primary border-start border-primary border-3">
                  <i className="fas fa-edit me-2"></i>
                  <strong>Cadastrando Cliente:</strong> Preencha os dados abaixo
                </div>

                {/* Mensagens agora são exibidas como toast (react-toastify) */}

                <div className="row g-3">
                  {/* Campo Empresa */}
                  <div className="col-md-12">
                    <label className="form-label fw-bold">
                      <i className="fas fa-building me-2 text-primary"></i>
                      Nome da Empresa <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={dadosFormulario.empresa}
                      onChange={(e) => handleInputChange('empresa', e.target.value)}
                      placeholder="Digite o nome da empresa"
                      disabled={cadastrandoCliente}
                    />
                  </div>

                  {/* Campo Número Domínio */}
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-barcode me-2 text-primary"></i>
                      Número do Domínio <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={dadosFormulario.numero_dominio}
                      onChange={(e) => handleInputChange('numero_dominio', e.target.value)}
                      placeholder="Ex: 12345"
                      disabled={cadastrandoCliente}
                    />
                  </div>

                  {/* Campo Operador */}
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-user-tie me-2 text-primary"></i>
                      Operador Responsável <span className="text-danger">*</span>
                    </label>
                    {carregandoOperadores ? (
                      <div className="d-flex align-items-center p-3 bg-light rounded-lg">
                        <div className="spinner-border spinner-border-sm text-primary me-2"></div>
                        <span className="text-muted">Carregando operadores...</span>
                      </div>
                    ) : operadoresDisponiveis.length > 0 ? (
                      <div>
                        <div className="input-group mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar operador..."
                            value={operadorFiltrado}
                            onChange={(e) => setOperadorFiltrado(e.target.value)}
                            disabled={cadastrandoCliente}
                          />
                          <span className="input-group-text">
                            <i className="fas fa-search"></i>
                          </span>
                        </div>
                        
                        {dadosFormulario.operador && (
                          <div className="alert alert-success py-2 mb-2">
                            <i className="fas fa-check-circle me-2"></i>
                            <strong>Selecionado:</strong> {dadosFormulario.operador}
                          </div>
                        )}
                        
                        <div style={{maxHeight: '250px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '0.375rem', padding: '0.5rem'}}>
                          {operadoresFiltrados.length > 0 ? (
                            <div className="list-group list-group-flush">
                              {operadoresFiltrados.map((operador, index) => (
                                <button
                                  key={index}
                                  type="button"
                                  className={`list-group-item list-group-item-action ${
                                    dadosFormulario.operador === operador 
                                      ? 'active bg-primary' 
                                      : 'text-start'
                                  }`}
                                  onClick={() => selecionarOperador(operador)}
                                  disabled={cadastrandoCliente}
                                >
                                  <i className="fas fa-user-circle me-2"></i>
                                  {operador}
                                  {dadosFormulario.operador === operador && (
                                    <i className="fas fa-check float-end mt-1"></i>
                                  )}
                                </button>
                              ))}
                            </div>
                          ) : (
                            <div className="text-center text-muted py-3">
                              <i className="fas fa-search me-2"></i>
                              Nenhum operador encontrado
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="alert alert-warning mb-0">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        Nenhum operador disponível no sistema
                      </div>
                    )}
                  </div>

                  {/* Campo CNPJ/CPF (vindo do CustomerX) */}
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-id-card me-2 text-primary"></i>
                      CNPJ / CPF
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      value={dadosFormulario.cnpj}
                      onChange={(e) => handleInputChange('cnpj', e.target.value)}
                      placeholder="Vindo do CustomerX (se houver)"
                      disabled={cadastrandoCliente}
                    />
                  </div>

                  {/* Campo E-mail (vindo do CustomerX) */}
                  <div className="col-md-6">
                    <label className="form-label fw-bold">
                      <i className="fas fa-envelope me-2 text-primary"></i>
                      E-mail
                    </label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      value={dadosFormulario.email}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                      placeholder="Vindo do CustomerX (se houver)"
                      disabled={cadastrandoCliente}
                    />
                  </div>

                  {/* Informações do CustomerX */}
                  <div className="col-12">
                    <div className="alert alert-info mb-0 border-start border-info border-3">
                      <i className="fas fa-info-circle me-2"></i>
                      <strong>Informações do CustomerX: ATENÇÃO PREENCHA O RESTANTE DOS DADOS POSTERIORMENTE</strong><br />
                      <div className="mt-2">
                        <small>
                          <i className="fas fa-calendar-alt me-1 text-info"></i>
                          <strong>Competência:</strong> {clienteSelecionado?.Competência || '-'} &nbsp;&nbsp;&nbsp;
                          <i className="fas fa-flag me-1 text-info"></i>
                          <strong>Status:</strong> {clienteSelecionado?.Status || '-'}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          
          <div className="modal-footer bg-light">
            {showFormCadastro ? (
              <>
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setShowFormCadastro(false);
                    setClienteSelecionado(null);
                    setMensagemCadastro('');
                    setOperadorFiltrado('');
                  }}
                  disabled={cadastrandoCliente}
                >
                  <i className="fas fa-arrow-left me-2"></i>
                  Voltar
                </button>
                <button 
                  type="button" 
                  className="btn btn-success btn-lg" 
                  onClick={cadastrarCliente}
                  disabled={cadastrandoCliente || carregandoOperadores || !dadosFormulario.operador}
                >
                  {cadastrandoCliente ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                      Cadastrando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save me-2"></i>
                      Confirmar Cadastro
                    </>
                  )}
                </button>
              </>
            ) : (
              <button 
                type="button" 
                className="btn btn-secondary" 
                onClick={handleClose}
              >
                <i className="fas fa-times me-2"></i>
                Fechar
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Seleção obrigatória da origem do atraso, usada nos modais de entrega
// Parcial / Atrasada / Atrasada e Parcial. Escolha exclusiva (radio), porque
// a entrega tem uma origem só — o detalhe fica na observação em texto livre.
const SeletorOrigemAtraso = ({
  valor, onChange, desabilitado, grupo = 'origem_atraso', compacto = false,
  mensagemFaltando = 'Selecione a origem para registrar a entrega.',
  rotulo = 'Origem do Atraso'
}) => {
  const opcoes = [
    {
      id: 'INTERNO',
      titulo: 'Interno',
      ajuda: 'Gargalo nosso: acúmulo, conciliação, férias, sistema, retrabalho',
      icone: 'fa-building',
      cor: '#b45309',
      fundo: '#fffbeb',
      borda: '#fcd34d'
    },
    {
      id: 'EXTERNO',
      titulo: 'Externo',
      ajuda: 'Depende do cliente ou de terceiro: documentos, extrato, retorno',
      icone: 'fa-user-clock',
      cor: '#1e40af',
      fundo: '#eff6ff',
      borda: '#bfdbfe'
    }
  ];

  return (
    <div className={compacto ? 'mb-2' : 'mb-3'}>
      <label className={`form-label ${compacto ? 'small mb-1' : ''}`}>
        <strong>{rotulo}:</strong>
        <span className="text-danger">*</span>
      </label>
      <div className="row g-2">
        {opcoes.map(op => {
          const ativo = valor === op.id;
          return (
            <div className="col-md-6" key={op.id}>
              <label
                className="d-flex align-items-start gap-2 p-2 rounded h-100 mb-0"
                style={{
                  cursor: desabilitado ? 'not-allowed' : 'pointer',
                  backgroundColor: ativo ? op.fundo : '#ffffff',
                  border: `2px solid ${ativo ? op.cor : '#dee2e6'}`,
                  transition: 'all 0.15s ease'
                }}
              >
                <input
                  type="radio"
                  name={grupo}
                  className="form-check-input mt-1 flex-shrink-0"
                  checked={ativo}
                  onChange={() => onChange(op.id)}
                  disabled={desabilitado}
                  style={{ cursor: desabilitado ? 'not-allowed' : 'pointer' }}
                />
                <span>
                  <span className="fw-bold d-block" style={{ fontSize: '0.9rem', color: ativo ? op.cor : '#212529' }}>
                    <i className={`fas ${op.icone} me-1`}></i>
                    {op.titulo}
                  </span>
                  <span className="text-muted" style={{ fontSize: '0.72rem', lineHeight: 1.35 }}>
                    {op.ajuda}
                  </span>
                </span>
              </label>
            </div>
          );
        })}
      </div>
      {!valor && mensagemFaltando && (
        <small className="text-danger d-block mt-1">
          <i className="fas fa-exclamation-circle me-1"></i>
          {mensagemFaltando}
        </small>
      )}
    </div>
  );
};


// COBRANÇA RETROATIVA DA ORIGEM DO ATRASO (INTERNO / EXTERNO)
// A classificação passou a ser obrigatória ao registrar a entrega, mas as
// empresas que já estavam em atraso ficaram sem ela — e sem isso não há como
// dizer onde está o gargalo. Aqui o operador só clica: nada para digitar.
const NotificationOrigemAtraso = ({ username }) => {
  const [showModal, setShowModal] = useState(false);
  const [itens, setItens] = useState([]);          // lote exibido agora
  const [total, setTotal] = useState(0);
  const [origens, setOrigens] = useState({});      // dominio|competencia -> INTERNO/EXTERNO
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  // Carteira com muitos atrasos travaria o operador; cobramos os mais
  // atrasados primeiro e o resto na próxima abertura da tela.
  const TAMANHO_LOTE = 15;

  const chave = (i) => `${i.numero_dominio}|${i.competencia}`;

  useEffect(() => {
    if (!username || username === 'usuário') return;

    const buscar = async () => {
      try {
        const accessToken = localStorage.getItem('access');
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/atrasos-sem-origem/`,
          {
            params: { operador: username },
            headers: { Authorization: `Bearer ${accessToken}` }
          }
        );
        const pendentes = res.data.pendentes || [];
        if (res.data.success && pendentes.length > 0) {
          setItens(pendentes.slice(0, TAMANHO_LOTE));
          setTotal(pendentes.length);
          setShowModal(true);
        }
      } catch (error) {
        console.error('Erro ao verificar atrasos sem origem:', error);
      }
    };

    buscar();
  }, [username]);

  const todasClassificadas = itens.length > 0 && itens.every(i => origens[chave(i)]);
  const faltam = itens.filter(i => !origens[chave(i)]).length;

  const salvar = async () => {
    if (!todasClassificadas) return;
    setSalvando(true);
    setErro('');
    try {
      const accessToken = localStorage.getItem('access');
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/salvar-origem-atraso/`,
        {
          origens: itens.map(i => ({
            numero_dominio: i.numero_dominio,
            empresa: i.empresa,
            operador: i.operador,
            competencia: i.competencia,
            dias_atraso: i.dias_atraso,
            origem_atraso: origens[chave(i)]
          }))
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (res.data.success) {
        setShowModal(false);
      } else {
        setErro(res.data.erro || 'Não foi possível salvar as classificações.');
      }
    } catch (error) {
      setErro(error.response?.data?.erro || 'Erro ao salvar as classificações.');
    } finally {
      setSalvando(false);
    }
  };

  if (!showModal) return null;

  return (
    <div
      className="modal"
      tabIndex="-1"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.85)',
        zIndex: 9999,
        backdropFilter: 'blur(3px)'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content shadow-lg border-primary border-3" onClick={(e) => e.stopPropagation()}>
          {/* sem botão de fechar: a classificação é obrigatória */}
          <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
            <h5 className="modal-title mb-0 fw-bold w-100 text-center" style={{ color: '#212529' }}>
              <i className="fas fa-diagram-project me-2"></i>
              AÇÃO OBRIGATÓRIA: classifique a causa dos atrasos
            </h5>
          </div>

          <div className="modal-body">
            <div className="alert alert-primary border-start border-primary border-5">
              <div className="d-flex align-items-center">
                <i className="fas fa-circle-info fa-2x me-3 text-primary"></i>
                <div>
                  <strong>
                    {total} empresa(s) em atraso sem a causa informada
                    {total > itens.length && ` — classifique ${itens.length} agora`}
                  </strong>
                  <p className="mb-0 mt-1 small">
                    Passamos a registrar se o atraso é <strong>interno</strong> (gargalo nosso)
                    ou <strong>externo</strong> (depende do cliente ou de terceiro). Estas empresas
                    já estavam em atraso antes disso. É só marcar a causa de cada uma —
                    não precisa escrever nada.
                    {total > itens.length &&
                      ` As ${total - itens.length} restantes serão pedidas em seguida.`}
                  </p>
                </div>
              </div>
            </div>

            {erro && (
              <div className="alert alert-danger py-2">
                <i className="fas fa-circle-exclamation me-2"></i>{erro}
              </div>
            )}

            {itens.map((i) => {
              const k = chave(i);
              const marcado = !!origens[k];
              return (
                <div
                  key={k}
                  className="card mb-3"
                  style={{ borderColor: marcado ? '#198754' : '#0d6efd', borderWidth: '2px' }}
                >
                  <div
                    className="card-header d-flex justify-content-between align-items-center"
                    style={{ backgroundColor: marcado ? '#f0fdf4' : '#eff6ff' }}
                  >
                    <span className="fw-bold" style={{ fontSize: '0.92rem' }}>
                      <i className={`fas ${marcado ? 'fa-circle-check text-success' : 'fa-circle-exclamation text-primary'} me-2`}></i>
                      {i.empresa}
                    </span>
                    <span>
                      <span className="badge bg-dark me-1">{i.competencia}</span>
                      <span className="badge bg-danger">{i.dias_atraso}d de atraso</span>
                    </span>
                  </div>
                  <div className="card-body py-2">
                    <div className="small text-muted mb-2">
                      <i className="fas fa-calendar-day me-1"></i>
                      Última entrega <strong>{i.ultima_entrega}</strong> · vencia
                      em <strong>{i.proxima_entrega}</strong> · {i.tipo_entrega}
                      {i.regime && i.regime !== '-' && ` · ${i.regime}`}
                    </div>
                    {i.observacao && (
                      <div className="small mb-2 p-2 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                        <i className="fas fa-quote-left me-1 text-muted"></i>
                        <span className="text-muted">Motivo já registrado:</span>{' '}
                        <em>{i.observacao}</em>
                      </div>
                    )}
                    <SeletorOrigemAtraso
                      valor={origens[k] || ''}
                      onChange={(v) => setOrigens(prev => ({ ...prev, [k]: v }))}
                      desabilitado={salvando}
                      grupo={`origem_retro_${k}`}
                      compacto
                      mensagemFaltando=""
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="modal-footer bg-light flex-column align-items-stretch gap-2">
            {faltam > 0 && (
              <div className="text-center small text-danger fw-bold">
                <i className="fas fa-circle-exclamation me-1"></i>
                Faltam {faltam} classificação(ões) para liberar o acesso.
              </div>
            )}
            <button
              type="button"
              className="btn btn-primary btn-lg w-100 fw-bold"
              onClick={salvar}
              disabled={!todasClassificadas || salvando}
              style={{ opacity: todasClassificadas ? 1 : 0.6 }}
            >
              {salvando ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Salvando...
                </>
              ) : (
                <>
                  <i className="fas fa-floppy-disk me-2"></i>
                  Salvar {itens.length} classificação(ões)
                  {total > itens.length ? ` (restam ${total - itens.length})` : ' e continuar'}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// MODAL PREVENTIVO DE SLA (Lucro Real / Lucro Presumido)
// A um dia do prazo, pergunta ao operador se vai conseguir entregar.
// "Não" exige motivo e dispara alerta imediato para a auditoria (Bárbara e
// Juliana) e, em e-mail separado, para o gestor — para agir ANTES do
// vencimento, não depois.
const NotificationPrevisaoSLA = ({ username }) => {
  const [showModal, setShowModal] = useState(false);
  const [itens, setItens] = useState([]);
  const [respostas, setRespostas] = useState({});   // chave -> 'Sim' | 'Nao'
  const [motivos, setMotivos] = useState({});       // chave -> texto
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const chave = (i) => `${i.numero_dominio}|${i.data_prevista}`;

  useEffect(() => {
    if (!username || username === 'usuário') return;

    const buscar = async () => {
      try {
        const accessToken = localStorage.getItem('access');
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/previsao-entrega-sla/`,
          {
            params: { operador: username },
            headers: { Authorization: `Bearer ${accessToken}` }
          }
        );
        if (res.data.success && (res.data.pendentes || []).length > 0) {
          setItens(res.data.pendentes);
          setShowModal(true);
        }
      } catch (error) {
        console.error('Erro ao verificar previsão de entrega (SLA):', error);
      }
    };

    buscar();
  }, [username]);

  // toda empresa precisa de resposta; quem respondeu "Não" precisa de motivo
  const completo = itens.length > 0 && itens.every(i => {
    const k = chave(i);
    if (!respostas[k]) return false;
    return respostas[k] === 'Sim' || (motivos[k] || '').trim().length > 0;
  });

  const qtdNao = itens.filter(i => respostas[chave(i)] === 'Nao').length;

  const enviar = async () => {
    if (!completo) return;
    setSalvando(true);
    setErro('');
    try {
      const accessToken = localStorage.getItem('access');
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/previsao-entrega-sla/responder/`,
        {
          respostas: itens.map(i => ({
            numero_dominio: i.numero_dominio,
            empresa: i.empresa,
            operador: i.operador,
            regime: i.regime,
            tipo_entrega: i.tipo_entrega,
            data_prevista: i.data_prevista,
            vai_entregar: respostas[chave(i)],
            motivo: (motivos[chave(i)] || '').trim()
          }))
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (res.data.success) {
        setShowModal(false);
      } else {
        setErro(res.data.erro || 'Não foi possível registrar as respostas.');
      }
    } catch (error) {
      setErro(error.response?.data?.erro || 'Erro ao registrar as respostas.');
    } finally {
      setSalvando(false);
    }
  };

  if (!showModal) return null;

  const faltam = itens.filter(i => {
    const k = chave(i);
    return !respostas[k] || (respostas[k] === 'Nao' && !(motivos[k] || '').trim());
  }).length;

  return (
    <div
      className="modal"
      tabIndex="-1"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.85)',
        zIndex: 9997,
        backdropFilter: 'blur(3px)'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content shadow-lg border-primary border-3" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
            <h5 className="modal-title mb-0 fw-bold w-100 text-center" style={{ color: '#212529' }}>
              <i className="fas fa-clock me-2"></i>
              CONFIRMAÇÃO DE PRAZO: entrega vence amanhã
            </h5>
          </div>

          <div className="modal-body">
            <div className="alert alert-primary border-start border-primary border-5">
              <div className="d-flex align-items-center">
                <i className="fas fa-triangle-exclamation fa-2x me-3 text-primary"></i>
                <div>
                  <strong>
                    {itens.length} empresa(s) de Lucro Real / Presumido com prazo vencendo
                  </strong>
                  <p className="mb-0 mt-1 small">
                    Confirme se vai conseguir entregar na data. Se responder <strong>Não</strong>,
                    a auditoria e a gestão são avisadas na hora para ajudar antes do vencimento.
                  </p>
                </div>
              </div>
            </div>

            {erro && (
              <div className="alert alert-danger py-2">
                <i className="fas fa-circle-exclamation me-2"></i>{erro}
              </div>
            )}

            {itens.map((i) => {
              const k = chave(i);
              const r = respostas[k];
              const pendente = !r || (r === 'Nao' && !(motivos[k] || '').trim());
              return (
                <div
                  key={k}
                  className="card mb-3"
                  style={{
                    borderWidth: '2px',
                    borderColor: pendente ? '#0d6efd' : (r === 'Nao' ? '#dc3545' : '#198754')
                  }}
                >
                  <div
                    className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2"
                    style={{ backgroundColor: pendente ? '#eff6ff' : (r === 'Nao' ? '#fff5f5' : '#f0fdf4') }}
                  >
                    <span className="fw-bold" style={{ fontSize: '0.92rem' }}>
                      <i className={`fas ${r === 'Sim' ? 'fa-circle-check text-success'
                        : r === 'Nao' ? 'fa-circle-xmark text-danger' : 'fa-circle-question text-primary'} me-2`}></i>
                      {i.empresa}
                    </span>
                    <span>
                      <span className="badge bg-dark me-1">{i.regime}</span>
                      <span className="badge bg-secondary me-1">{i.tipo_entrega}</span>
                      <span className="badge bg-danger">
                        {i.dias_restantes === 0 ? 'vence hoje' : 'vence amanhã'} · {i.data_prevista}
                      </span>
                    </span>
                  </div>
                  <div className="card-body py-3">
                    <label className="form-label small fw-semibold mb-2">
                      Vai conseguir entregar até {i.data_prevista}?
                      <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex gap-2 mb-2 flex-wrap">
                      <button
                        type="button"
                        className={`btn btn-sm ${r === 'Sim' ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => setRespostas(prev => ({ ...prev, [k]: 'Sim' }))}
                        disabled={salvando}
                        style={{ minWidth: '110px' }}
                      >
                        <i className="fas fa-check me-1"></i>Sim
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${r === 'Nao' ? 'btn-danger' : 'btn-outline-danger'}`}
                        onClick={() => setRespostas(prev => ({ ...prev, [k]: 'Nao' }))}
                        disabled={salvando}
                        style={{ minWidth: '110px' }}
                      >
                        <i className="fas fa-xmark me-1"></i>Não
                      </button>
                    </div>

                    {r === 'Nao' && (
                      <div>
                        <label className="form-label small fw-semibold mb-1 text-danger">
                          Por que não vai conseguir entregar?
                          <span className="text-danger">*</span>
                        </label>
                        <textarea
                          className="form-control"
                          rows="2"
                          maxLength="500"
                          placeholder="Ex.: cliente não enviou os extratos de agosto; aguardando retorno desde 05/09..."
                          value={motivos[k] || ''}
                          onChange={(e) => setMotivos(prev => ({ ...prev, [k]: e.target.value }))}
                          disabled={salvando}
                        />
                        <small className="text-muted">
                          <i className="fas fa-bell me-1"></i>
                          A auditoria e a gestão recebem este motivo imediatamente.
                        </small>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="modal-footer bg-light flex-column align-items-stretch gap-2">
            {faltam > 0 && (
              <div className="text-center small text-danger fw-bold">
                <i className="fas fa-circle-exclamation me-1"></i>
                Faltam {faltam} confirmação(ões) para liberar o acesso.
              </div>
            )}
            {qtdNao > 0 && faltam === 0 && (
              <div className="text-center small fw-bold" style={{ color: '#b02a37' }}>
                <i className="fas fa-bell me-1"></i>
                {qtdNao} alerta(s) de risco será(ão) enviado(s) à auditoria e à gestão.
              </div>
            )}
            <button
              type="button"
              className="btn btn-primary btn-lg w-100 fw-bold"
              onClick={enviar}
              disabled={!completo || salvando}
              style={{ opacity: completo ? 1 : 0.6 }}
            >
              {salvando ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Registrando...
                </>
              ) : (
                <>
                  <i className="fas fa-paper-plane me-2"></i>
                  Confirmar {itens.length} prazo(s) e continuar
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// MODAL OBRIGATÓRIO: justificativa do relatório de fechamento não enviado
// Mesmo princípio do modal de +10 dias de atraso — o operador precisa dizer
// por que o relatório da competência entregue ainda não foi enviado ao cliente.
// Só entram clientes que ENTREGARAM o fechamento: quem está com a entrega em
// atraso é cobrado no fluxo de atrasos, não aqui.
const NotificationRelatorioPendente = ({ username }) => {
  const [showModal, setShowModal] = useState(false);
  const [pendentes, setPendentes] = useState([]);   // lote exibido agora
  const [totalPendente, setTotalPendente] = useState(0);
  const [prazoDias, setPrazoDias] = useState(3);
  const [obs, setObs] = useState({});           // numero_dominio+competencia -> texto
  const [origens, setOrigens] = useState({});   // numero_dominio+competencia -> INTERNO/EXTERNO
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  // Backlog grande travaria o operador (há carteira com 20+ pendentes), então
  // cobramos em lotes dos mais atrasados; o resto vem nas próximas aberturas.
  const TAMANHO_LOTE = 10;

  const chave = (p) => `${p.numero_dominio}|${p.competencia}`;

  useEffect(() => {
    if (!username || username === 'usuário') return;

    const buscar = async () => {
      try {
        const accessToken = localStorage.getItem('access');
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/api/relatorios-pendentes-justificativa/`,
          {
            params: { operador: username },
            headers: { Authorization: `Bearer ${accessToken}` }
          }
        );
        const semJust = res.data.sem_justificativa || [];
        if (res.data.success && semJust.length > 0) {
          setPendentes(semJust.slice(0, TAMANHO_LOTE));
          setTotalPendente(semJust.length);
          setPrazoDias(res.data.prazo_dias || 3);
          setShowModal(true);
        }
      } catch (error) {
        console.error('Erro ao verificar relatórios pendentes de justificativa:', error);
      }
    };

    buscar();
  }, [username]);

  const todasPreenchidas = pendentes.length > 0 &&
    pendentes.every(p => (obs[chave(p)] || '').trim().length > 0 && origens[chave(p)]);

  const salvar = async () => {
    if (!todasPreenchidas) return;
    setSalvando(true);
    setErro('');
    try {
      const accessToken = localStorage.getItem('access');
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/salvar-observacao-relatorio/`,
        {
          observacoes: pendentes.map(p => ({
            numero_dominio: p.numero_dominio,
            empresa: p.empresa,
            operador: p.operador,
            competencia: p.competencia,
            observacao: (obs[chave(p)] || '').trim(),
            origem_atraso: origens[chave(p)]
          }))
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (res.data.success) {
        setShowModal(false);
      } else {
        setErro(res.data.erro || 'Não foi possível salvar as justificativas.');
      }
    } catch (error) {
      setErro(error.response?.data?.erro || 'Erro ao salvar as justificativas.');
    } finally {
      setSalvando(false);
    }
  };

  if (!showModal) return null;

  const faltam = pendentes.filter(
    p => !(obs[chave(p)] || '').trim() || !origens[chave(p)]
  ).length;

  return (
    <div
      className="modal"
      tabIndex="-1"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0,0,0,0.85)',
        zIndex: 9998,
        backdropFilter: 'blur(3px)'
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content shadow-lg border-warning border-3" onClick={(e) => e.stopPropagation()}>
          {/* sem botão de fechar: a justificativa é obrigatória */}
          <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
            <h5 className="modal-title mb-0 fw-bold w-100 text-center" style={{ color: '#212529' }}>
              <i className="fas fa-file-circle-exclamation me-2"></i>
              AÇÃO OBRIGATÓRIA: Relatório de Fechamento não enviado
            </h5>
          </div>

          <div className="modal-body">
            <div className="alert alert-warning border-start border-warning border-5">
              <div className="d-flex align-items-center">
                <i className="fas fa-triangle-exclamation fa-2x me-3 text-warning"></i>
                <div>
                  <strong>
                    {totalPendente} cliente(s) com o relatório de fechamento em atraso
                    {totalPendente > pendentes.length && ` — justifique ${pendentes.length} agora`}
                  </strong>
                  <p className="mb-0 mt-1 small">
                    O relatório deve ser enviado em até <strong>{prazoDias} dias</strong> após a entrega
                    do fechamento. Informe o motivo do atraso de cada cliente.
                    {totalPendente > pendentes.length &&
                      ` Os ${totalPendente - pendentes.length} restantes serão cobrados em seguida.`}
                  </p>
                  <p className="mb-0 mt-1 small text-muted">
                    Clientes com a <strong>entrega</strong> em atraso não aparecem aqui — esses são
                    tratados no fluxo de atrasos.
                  </p>
                </div>
              </div>
            </div>

            {erro && (
              <div className="alert alert-danger py-2">
                <i className="fas fa-circle-exclamation me-2"></i>{erro}
              </div>
            )}

            {pendentes.map((p) => {
              const k = chave(p);
              const preenchido = (obs[k] || '').trim().length > 0 && !!origens[k];
              return (
                <div
                  key={k}
                  className="card mb-3"
                  style={{ borderColor: preenchido ? '#198754' : '#ffc107', borderWidth: '2px' }}
                >
                  <div
                    className="card-header d-flex justify-content-between align-items-center"
                    style={{ backgroundColor: preenchido ? '#f0fdf4' : '#fffbeb' }}
                  >
                    <span className="fw-bold" style={{ fontSize: '0.92rem' }}>
                      <i className={`fas ${preenchido ? 'fa-circle-check text-success' : 'fa-circle-exclamation text-warning'} me-2`}></i>
                      {p.empresa}
                    </span>
                    <span>
                      <span className="badge bg-dark me-1">{p.competencia}</span>
                      <span className="badge bg-danger">
                        {p.dias_atraso_relatorio}d após o prazo
                      </span>
                    </span>
                  </div>
                  <div className="card-body py-2">
                    <div className="small text-muted mb-2">
                      <i className="fas fa-calendar-check me-1"></i>
                      {p.conclusao_registrada ? 'Concluído em ' : 'Entrega prevista '}
                      <strong>{p.data_entrega}</strong>
                      {p.conclusao_registrada && p.data_prevista && p.data_prevista !== p.data_entrega && (
                        <span className="text-muted"> (previsto para {p.data_prevista})</span>
                      )}
                      {' '}· prazo do relatório até <strong>{p.prazo_envio}</strong> · {p.tipo_entrega}
                      {p.nunca_enviado && (
                        <span className="badge bg-secondary ms-2">nunca recebeu relatório</span>
                      )}
                      {p.sem_email_socio && (
                        <span className="badge bg-danger ms-2" title="Cadastre o e-mail do sócio para liberar o envio">
                          sem e-mail do sócio
                        </span>
                      )}
                    </div>
                    <SeletorOrigemAtraso
                      valor={origens[k] || ''}
                      onChange={(v) => setOrigens(prev => ({ ...prev, [k]: v }))}
                      desabilitado={salvando}
                      grupo={`origem_rel_${k}`}
                      compacto
                    />

                    <label className="form-label small fw-semibold mb-1">
                      Por que o relatório ainda não foi enviado?
                      <span className="text-danger">*</span>
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      maxLength="500"
                      placeholder="Ex.: aguardando conciliação do cartão; cliente pediu para enviar junto com o próximo mês..."
                      value={obs[k] || ''}
                      onChange={(e) => setObs(prev => ({ ...prev, [k]: e.target.value }))}
                      disabled={salvando}
                    />
                    <small className="text-muted">{(obs[k] || '').length}/500 caracteres</small>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="modal-footer bg-light flex-column align-items-stretch gap-2">
            {faltam > 0 && (
              <div className="text-center small text-danger fw-bold">
                <i className="fas fa-circle-exclamation me-1"></i>
                Faltam {faltam} justificativa(s) para liberar o acesso.
              </div>
            )}
            <button
              type="button"
              className="btn btn-warning btn-lg w-100 fw-bold"
              onClick={salvar}
              disabled={!todasPreenchidas || salvando}
              style={{ opacity: todasPreenchidas ? 1 : 0.6 }}
            >
              {salvando ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Salvando...
                </>
              ) : (
                <>
                  <i className="fas fa-floppy-disk me-2"></i>
                  Salvar {pendentes.length} justificativa(s)
                  {totalPendente > pendentes.length
                    ? ` (restam ${totalPendente - pendentes.length})`
                    : ' e continuar'}
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Domínio 0 é código válido (cliente de teste): não tratar como vazio
const temDominio = (v) => v !== null && v !== undefined && String(v).trim() !== '';

const MultiSelectDropdown = ({ options, selected, onChange, placeholder = 'Todos' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggle = (val) => {
    onChange(selected.includes(val) ? selected.filter(v => v !== val) : [...selected, val]);
  };

  const label = selected.length === 0
    ? placeholder
    : selected.length === 1
    ? selected[0]
    : `${selected.length} selecionados`;

  return (
    <div ref={ref} style={{ position: 'relative' }} className="mt-1">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="form-select form-select-sm text-start"
        style={{ paddingRight: '2rem', background: selected.length > 0 ? '#e8f4ff' : undefined, borderColor: selected.length > 0 ? '#0d6efd' : undefined }}
      >
        <span style={{ fontSize: '0.8rem' }}>{label}</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', zIndex: 1050, background: 'white',
          border: '1px solid #dee2e6', borderRadius: '0.375rem',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          minWidth: '200px', maxHeight: '260px', overflowY: 'auto',
          top: 'calc(100% + 2px)', left: 0,
        }}>
          {selected.length > 0 && (
            <div
              onClick={() => onChange([])}
              className="px-3 py-2 border-bottom text-danger"
              style={{ cursor: 'pointer', fontSize: '0.8rem' }}
            >
              <i className="fas fa-times me-1"></i> Limpar seleção
            </div>
          )}
          {options.map(opt => (
            <label
              key={opt}
              className="d-flex align-items-center px-3 py-2 gap-2 m-0"
              style={{ cursor: 'pointer', fontSize: '0.85rem', borderBottom: '1px solid #f8f9fa' }}
            >
              <input
                type="checkbox"
                checked={selected.includes(opt)}
                onChange={() => toggle(opt)}
                style={{ cursor: 'pointer' }}
              />
              {opt}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

const Contabilidade = () => {
  // Declare all hooks first
  const [empresas, setEmpresas] = useState([]);
  const [selecionadas, setSelecionadas] = useState([]);
  const [mensagem, setMensagem] = useState('');

  // Ponte para toasts (react-toastify)
  useEffect(() => { notificar(mensagem); }, [mensagem]);

  const [carregando, setCarregando] = useState(true);
  const [operadoresUnicos, setOperadoresUnicos] = useState([]);
  const [detalhesEmpresa, setDetalhesEmpresa] = useState(null);
  const [detalhesEditaveis, setDetalhesEditaveis] = useState(null);
  const [modoEdicao, setModoEdicao] = useState(false);
  const [salvandoDetalhes, setSalvandoDetalhes] = useState(false);
  const [mostrarModalDetalhes, setMostrarModalDetalhes] = useState(false);
  // NOTAS GERENCIAIS (observacoes_gerenciais) - várias por empresa (título + descrição)
  const [notasGerenciais, setNotasGerenciais] = useState([]);
  const [notaForm, setNotaForm] = useState({ id: null, titulo: '', descricao: '', link: '' });
  const [salvandoNota, setSalvandoNota] = useState(false);
  // ANEXOS DAS NOTAS GERENCIAIS
  const [notaAnexoAtivoId, setNotaAnexoAtivoId] = useState(null);
  // "COMO FAZER" — procedimento único por empresa (procedimento_empresa)
  const [modoEdicaoComoFazer, setModoEdicaoComoFazer] = useState(false);
  const [comoFazerEditavel, setComoFazerEditavel] = useState('');
  const [salvandoComoFazer, setSalvandoComoFazer] = useState(false);
  const [enviandoAnexoNotaId, setEnviandoAnexoNotaId] = useState(null);
  // Blob URLs (createObjectURL) dos anexos, buscados via axios com o token —
  // o bucket é privado, então não dá pra usar <img src> direto na API.
  const [anexoUrls, setAnexoUrls] = useState({});
  // Modal com a data do último relatório enviado
  const [modalRelatorioInfo, setModalRelatorioInfo] = useState(null);
  const [mostrarModalEntregaParcial, setMostrarModalEntregaParcial] = useState(false);
  const [textoEntregaParcial, setTextoEntregaParcial] = useState('');
  
  // Estado para o modal de entrega
  const [mostrarModalEntrega, setMostrarModalEntrega] = useState(false);
  const [empresaSelecionada, setEmpresaSelecionada] = useState(null);
  const [competenciaSelecionada, setCompetenciaSelecionada] = useState('');
  const [proximasCompetencias, setProximasCompetencias] = useState([]);
  const [entregaCarregando, setEntregaCarregando] = useState(false);
  
  // Estados para o histórico
  const [mostrarModalHistorico, setMostrarModalHistorico] = useState(false);
  const [historicoEntregas, setHistoricoEntregas] = useState([]);
  const [historicoCarregando, setHistoricoCarregando] = useState(false);
  const [filtroHistorico, setFiltroHistorico] = useState('');

  // Estados para entrega atrasada
  const [mostrarModalEntregaAtrasada, setMostrarModalEntregaAtrasada] = useState(false);
  const [textoEntregaAtrasada, setTextoEntregaAtrasada] = useState('');

  // ORIGEM DO ATRASO (obrigatória nas entregas Parcial / Atrasada /
  // Atrasada e Parcial): separa gargalo INTERNO (nosso) de EXTERNO
  // (cliente/terceiro) para medir onde a operação trava.
  const [origemAtraso, setOrigemAtraso] = useState('');

  // NOVOS ESTADOS PARA ENTREGA ATRASADA PARCIAL
  const [mostrarModalEntregaAtrasadaParcial, setMostrarModalEntregaAtrasadaParcial] = useState(false);
  const [textoEntregaAtrasadaParcial, setTextoEntregaAtrasadaParcial] = useState('');
  const [colunaOrdenacao, setColunaOrdenacao] = useState('proxima_entrega'); // 'ultima_entrega' ou 'proxima_entrega'
  const [ordemUltimaEntrega, setOrdemUltimaEntrega] = useState('desc');
  const [ordemEmpresa, setOrdemEmpresa] = useState('asc'); // 'asc' = A a Z


  // NOVOS ESTADOS PARA CONTROLE DE ACESSO
  const [carregandoAcesso, setCarregandoAcesso] = useState(true);
  const [acessoNegado, setAcessoNegado] = useState(false);
  const [dadosUsuario, setDadosUsuario] = useState(null);

  // ESTADOS PARA PENDÊNCIAS
  const [pendenciasUsuario, setPendenciasUsuario] = useState([]);
  // numero_dominio -> nº de entregas parciais não resolvidas (mesma regra da tela Pendências)
  const [pendenciasPorEmpresa, setPendenciasPorEmpresa] = useState({});
  const [carregandoPendencias, setCarregandoPendencias] = useState(false);
  const [totalPendencias, setTotalPendencias] = useState(0);

  // ESTADOS PARA PENDÊNCIAS DE AUDITORIA
  const [totalPendenciasAuditoria, setTotalPendenciasAuditoria] = useState(0);
  const [carregandoPendenciasAuditoria, setCarregandoPendenciasAuditoria] = useState(false);

  
  // ESTADOS PARA OUTBOARDING DO OPERADOR
  const [outboardingOperador, setOutboardingOperador] = useState([]);
  const [carregandoOutboarding, setCarregandoOutboarding] = useState(false);
  const [totalOutboarding, setTotalOutboarding] = useState(0);
  const [nomesClientesOutboarding, setNomesClientesOutboarding] = useState([]);

  const [mostrarModalConfirmacao, setMostrarModalConfirmacao] = useState(false);
const [inativandoCliente, setInativandoCliente] = useState(false);

// GRUPOS DISPONÍVEIS
const [gruposDisponiveis, setGruposDisponiveis] = useState([]);

const [mostrarSomentesSelecionadas, setMostrarSomentesSelecionadas] = useState(false);

useEffect(() => {
  const accessToken = localStorage.getItem('access');
  axios
    .get(`${process.env.REACT_APP_API_BASE}/api/empresas-contabil/`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    })
    .then((res) => {
      const empresasCarregadas = res.data.empresas || [];
      const grupos = [...new Set(empresasCarregadas.map(emp => emp.grupo).filter(Boolean))].sort();
      setGruposDisponiveis(grupos);
    })
    .catch(() => {});
}, []);


// CONTROLES FINANCEIROS DISPONÍVEIS
const [controlesFinanceiros, setControlesFinanceiros] = useState([]);

useEffect(() => {
  const accessToken = localStorage.getItem('access');
  axios
    .get(`${process.env.REACT_APP_API_BASE}/api/empresas-contabil/`, {
      headers: { Authorization: `Bearer ${accessToken}` }
    })
    .then((res) => {
      const empresasCarregadas = res.data.empresas || [];
      const controles = [...new Set(empresasCarregadas.map(emp => emp.controle_financeiro).filter(Boolean))].sort();
      setControlesFinanceiros(controles);
    })
    .catch(() => {});
}, []);

  // FUNÇÃO PARA EXPORTAR HISTÓRICO PARA EXCEL
  const exportarHistoricoParaExcel = () => {
    if (historicoFiltrado.length === 0) {
      setMensagem('Nenhum dado para exportar.');
      return;
    }

    // Preparar dados para exportação
    const dadosParaExportar = historicoFiltrado.map(item => ({
      'Data/Hora': item.data_hoje,
      'Empresa': item.empresa,
      'Competência': item.entregue,
      'Nº Domínio': item.numero_dominio,
      'Tipo Entrega': item.tipo_entrega || 'Completa',
      'Operador': item.operador || 'N/A',
      'Status Entrega': item.status_entrega || 'Não informado',
      'Origem do Atraso': item.origem_atraso === 'INTERNO' ? 'Interno'
        : item.origem_atraso === 'EXTERNO' ? 'Externo' : '',
      'Observação': item.texto_livre || 'Sem observações',
      'Resolvido': item.resolvido || 'Não'
    }));

    // Converter para CSV
    const headers = Object.keys(dadosParaExportar[0]);
    const csvContent = [
      headers.join(','),
      ...dadosParaExportar.map(row => 
        headers.map(header => {
          const value = row[header];
          // Escapar vírgulas e aspas
          if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        }).join(',')
      )
    ].join('\n');

    // Criar e baixar arquivo
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    
    // Nome do arquivo com data atual
    const dataAtual = new Date().toISOString().split('T')[0];
    const nomeArquivo = `historico_contabil_${dataAtual}.csv`;
    link.setAttribute('download', nomeArquivo);
    
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setMensagem(`Histórico exportado com sucesso! (${historicoFiltrado.length} registros)`);
  };

  // FUNÇÃO PARA EXPORTAR A TABELA DE CLIENTES PARA EXCEL (respeita os filtros)
  const exportarClientesParaExcel = () => {
    if (empresasFiltradas.length === 0) {
      setMensagem('Nenhum cliente para exportar.');
      return;
    }

    const dados = empresasFiltradas.map(emp => ({
      'Nº Domínio': temDominio(emp.numero_dominio) ? emp.numero_dominio : '-',
      'Empresa': emp.empresa || '-',
      'Drive Cliente': (emp.drive_cliente && emp.drive_cliente !== '-') ? emp.drive_cliente : '-',
      'Última Entrega': emp.ultima_entrega ? formatarCompetencia(emp.ultima_entrega) : '-',
      'Próxima Entrega': emp.proxima_entrega || '-',
      'Regime': emp.regime || '-',
      'Operador': emp.operador || '-',
      'Status Contábil': emp.Status_contabil || 'Não definido',
      'Status Relatório': calcularStatusRelatorio(emp.ultima_entrega, emp.ultimo_relatorio_mes_ano, emp.tipo_entrega) || '-',
      'Tipo Entrega': emp.tipo_entrega || '-',
      'Controle Financeiro': emp.controle_financeiro || '-',
      'Grupo': emp.grupo || '-'
    }));

    const ws = XLSX.utils.json_to_sheet(dados);
    ws['!cols'] = Object.keys(dados[0]).map(chave => ({
      wch: Math.max(chave.length, ...dados.map(l => String(l[chave] ?? '').length)) + 2
    }));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Clientes');

    const dataAtual = new Date().toISOString().split('T')[0];
    XLSX.writeFile(wb, `clientes_contabil_${dataAtual}.xlsx`);
    setMensagem(`Tabela exportada com sucesso! (${empresasFiltradas.length} clientes)`);
  };

  // NOVA FUNÇÃO PARA VERIFICAR ACESSO
  const verificarAcesso = useCallback(async () => {
    setCarregandoAcesso(true);
    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );

      if (response.data.success) {
        const { usuario, first_name, grupo, name } = response.data;
        
        setDadosUsuario({
          username: usuario,
          first_name: first_name,
          grupo: grupo,
          name: name
        });

        // VERIFICAR SE O USUÁRIO TEM ACESSO
        if (grupo === 'rh') {
          setAcessoNegado(true);
        } else {
          setAcessoNegado(false);
        }
      } else {
        setAcessoNegado(true);
      }
    } catch (error) {
      console.error('Erro ao verificar acesso:', error);
      setAcessoNegado(true);
    } finally {
      setCarregandoAcesso(false);
    }
  }, []);

  // CHAMAR VERIFICAÇÃO DE ACESSO AO CARREGAR O COMPONENTE
  useEffect(() => {
    verificarAcesso();
  }, [verificarAcesso]);

  // Determinar o nome do usuário
  let username = 'usuário';
  if (dadosUsuario) {
    username = dadosUsuario.name || 
               dadosUsuario.first_name || 
               dadosUsuario.username || 
               'usuário';
  }

const [filtros, setFiltros] = useState({
  numero_dominio: [],
  empresa: '',
  drive_cliente: [],
  ultima_entrega: [],
  proxima_entrega: [],
  regime: [],
  operador: [],
  Status_contabil: [],
  status_relatorio: [],
  tipo_entrega: [],
  controle_financeiro: [],
  grupo: []
});

  // Atualizar o filtro de operador após verificar o acesso.
  // Resolve o login (ex.: "Regis") para o nome CANÔNICO gravado em
  // empresas.operador (ex.: "Regis Monteiro"), casando por primeiro nome —
  // sem isso o filtro exato não bate e o gráfico/tabela ficam vazios.
  // Só na PRIMEIRA carga: depois disso o filtro é do usuário. Antes, toda
  // recarga de `empresas` (salvar operador, editar cliente...) devolvia o
  // filtro ao próprio nome e obrigava a limpar e refazer tudo.
  // Link do boletim operacional: ?dominios=12,34,56&lista=Atraso acima de 30 dias
  // mostra só essas empresas (de qualquer operador) até o usuário limpar.
  const [filtroBoletim, setFiltroBoletim] = useState(() => {
    try {
      const qs = new URLSearchParams(window.location.search);
      const doms = (qs.get('dominios') || '').split(',').map(d => d.trim()).filter(Boolean);
      if (!doms.length) return null;
      return { dominios: new Set(doms), titulo: (qs.get('lista') || 'Empresas do boletim').slice(0, 80) };
    } catch (_) { return null; }
  });
  const limparFiltroBoletim = () => {
    setFiltroBoletim(null);
    try { window.history.replaceState(null, '', window.location.pathname); } catch (_) { /* sem history */ }
  };

  const filtroOperadorInicialAplicado = React.useRef(false);
  useEffect(() => {
    if (filtroOperadorInicialAplicado.current) return;
    if (filtroBoletim) { filtroOperadorInicialAplicado.current = true; return; }
    if (dadosUsuario && !acessoNegado && username !== 'usuário' && empresas.length > 0) {
      const primeiroNome = (s) => (s || '').trim().toLowerCase().split(/\s+/)[0];
      const alvo = primeiroNome(username);
      const canonico = [...new Set(empresas.map(e => e.operador).filter(Boolean))]
        .find(op => primeiroNome(op) === alvo);
      setFiltros(prev => ({
        ...prev,
        operador: canonico ? [canonico] : (username ? [username] : [])
      }));
      filtroOperadorInicialAplicado.current = true;
    }
  }, [dadosUsuario, acessoNegado, username, empresas]);

  // FUNÇÃO PARA VERIFICAR PENDÊNCIAS DO USUÁRIO
  const verificarPendenciasUsuario = useCallback(() => {
    if (!username || username === 'usuário') return;

    setCarregandoPendencias(true);
    const accessToken = localStorage.getItem('access');

    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/historico-contabil/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        const historico = res.data.historico || [];

        // Mapa de pendências abertas por empresa (ícone amarelo/cinza nas ações)
        const mapa = {};
        historico.forEach(item => {
          const tipo = item.tipo_entrega?.toLowerCase() || '';
          const resolvido = item.resolvido?.toLowerCase() || 'não';
          if ((tipo === 'parcial' || tipo === 'atrasada e parcial') && resolvido !== 'sim') {
            const nd = String(item.numero_dominio ?? '');
            mapa[nd] = (mapa[nd] || 0) + 1;
          }
        });
        setPendenciasPorEmpresa(mapa);
        
        // Filtrar APENAS entregas Parciais e Atrasadas e Parciais do operador logado que NÃO foram resolvidas
        const pendenciasDoUsuario = historico.filter(item => {
          const tipo = item.tipo_entrega?.toLowerCase() || '';
          const resolvido = item.resolvido?.toLowerCase() || 'não';
          const operador = item.operador || '';
          
          return (tipo === 'parcial' || tipo === 'atrasada e parcial') && 
                 resolvido !== 'sim' && 
                 operador.toLowerCase() === username.toLowerCase();
        });

        setPendenciasUsuario(pendenciasDoUsuario);
        setTotalPendencias(pendenciasDoUsuario.length);
        setCarregandoPendencias(false);
      })
      .catch((error) => {
        console.error('Erro ao carregar pendências:', error);
        setCarregandoPendencias(false);
      });
  }, [username]);

  // FUNÇÃO PARA VERIFICAR CLIENTES EM OUTBOARDING DO OPERADOR
  const verificarOutboardingOperador = useCallback(() => {
    if (!username || username === 'usuário') return;

    setCarregandoOutboarding(true);
    const accessToken = localStorage.getItem('access');

    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/customerx-outboarding/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        // PEGAR APENAS EMPRESAS EM PROCESSO (não finalizadas)
        // Vem da tabela cx_outboarding (carga noturna do saber_kanban/cx.py):
        // só quem está no card "Documentação" com status Pendente.
        const outboardingEmpresas = res.data.empresas_em_processo || [];
        
        console.log('Total de empresas em processo:', outboardingEmpresas.length);
        console.log('Operador logado:', username);
        
        // FILTRAR APENAS OS CLIENTES DO OPERADOR LOGADO E EM PROCESSO
        const clientesDoOperador = outboardingEmpresas.filter(empresa => {
          const responsavel = (empresa['Responsável Contábil'] || '').toLowerCase().trim();
          const nomeOperador = username.toLowerCase().trim();
          
          // console.log(`Comparando: "${responsavel}" com "${nomeOperador}"`);
          
          const matchExato = responsavel === nomeOperador;
          const matchInclusaoResponsavel = responsavel.includes(nomeOperador);
          const matchInclusaoOperador = nomeOperador.includes(responsavel);
          
          const temMatch = matchExato || matchInclusaoResponsavel || matchInclusaoOperador;
          
          if (temMatch) {
            // console.log(`Match encontrado: ${empresa.Empresa} - Responsável: ${responsavel}`);
          }
          
          return temMatch;
        });

        // console.log('Clientes filtrados do operador (em processo):', clientesDoOperador.length);
        // console.log('Lista de clientes:', clientesDoOperador.map(c => c.Empresa));
        
        // EXTRAIR NOMES DOS CLIENTES
        const nomesClientes = clientesDoOperador.map(c => c.Empresa || 'Cliente sem nome');
        setNomesClientesOutboarding(nomesClientes);

        setOutboardingOperador(clientesDoOperador);
        setTotalOutboarding(clientesDoOperador.length);
        setCarregandoOutboarding(false);
      })
      .catch((error) => {
        console.error('Erro ao carregar outboarding:', error);
        setCarregandoOutboarding(false);
      });
  }, [username]);

  const verificarPendenciasAuditoria = useCallback(() => {
    if (!username || username === 'usuário') return;

    setCarregandoPendenciasAuditoria(true);
    const accessToken = localStorage.getItem('access');

    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/listar-historico-auditoria/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        const auditorias = res.data.auditorias || [];
        // Casa pelo operador RESPONSÁVEL pela empresa (operador_empresa) e por
        // primeiro nome — o login é "Regis" e o dado é "Regis Monteiro".
        // Pendente = auditoria ainda não 100% resolvida.
        const primeiroNome = (s) => (s || '').trim().toLowerCase().split(/\s+/)[0];
        const u = primeiroNome(username);
        // a.pendente = ainda há item cobrável (nem resolvido, nem EM ANDAMENTO
        // vigente). Itens aguardando o cliente saem da conta nesta competência
        // e voltam na próxima. Fallback para !a.resolvido em respostas antigas.
        const pendentes = auditorias.filter(a => {
          const segueCobravel = a.pendente !== undefined ? a.pendente : !a.resolvido;
          return segueCobravel && u && primeiroNome(a.operador_empresa) === u;
        });
        setTotalPendenciasAuditoria(pendentes.length);
        setCarregandoPendenciasAuditoria(false);
      })
      .catch(() => setCarregandoPendenciasAuditoria(false));
  }, [username]);

  // useEffect PARA VERIFICAR PENDÊNCIAS QUANDO O OPERADOR MUDAR
  useEffect(() => {
    if (username !== 'usuário') {
      verificarPendenciasUsuario();
      verificarOutboardingOperador();
      verificarPendenciasAuditoria();
    }
  }, [verificarPendenciasUsuario, verificarOutboardingOperador, verificarPendenciasAuditoria, username]);


const converterDataParaComparacao = (dataString) => {
  if (!dataString || dataString === '-') return new Date('1900-01-01');
  
  try {
    if (dataString.includes('/')) {
      const partes = dataString.split('/');
      
      // Formato DD/MM/YYYY ou DD/MM/YY (3 partes)
      if (partes.length === 3) {
        const dia = parseInt(partes[0]);
        const mes = parseInt(partes[1]);
        let ano = parseInt(partes[2]);
        
        // Se ano tem 2 dígitos, converte para 4 dígitos
        if (ano < 100) {
          ano = ano < 50 ? 2000 + ano : 1900 + ano;
        }
        
        return new Date(ano, mes - 1, dia);
      }
      
      // Formato MM/YY (competência) - 2 partes
      if (partes.length === 2) {
        const mes = parseInt(partes[0]);
        let ano = parseInt(partes[1]);
        
        // Se ano tem 2 dígitos, converte para 4 dígitos
        if (ano < 100) {
          ano = ano < 50 ? 2000 + ano : 1900 + ano;
        }
        
        // Retorna primeiro dia do mês para comparação
        return new Date(ano, mes - 1, 1);
      }
    }
    
    if (dataString.includes('-')) {
      return new Date(dataString);
    }
    
    return new Date('1900-01-01');
  } catch (e) {
    console.error("Erro ao converter data:", dataString, e);
    return new Date('1900-01-01');
  }
};






  // Função para normalizar o status
  const normalizarStatus = (status) => {
    if (!status) return "Não definido";
    
    if (status.includes('(')) {
      return status.split('(')[0].trim();
    }
    
    return status;
  };

  const opcoesNumeroDominio = React.useMemo(() =>
    [...new Set(empresas.map(e => e.numero_dominio?.toString()).filter(Boolean))].sort(),
    [empresas]);

  const opcoesEmpresa = React.useMemo(() =>
    [...new Set(empresas.map(e => e.empresa).filter(Boolean))].sort(),
    [empresas]);

  const opcoesUltimaEntrega = React.useMemo(() =>
    [...new Set(empresas.map(e => {
      const ds = e.ultima_entrega;
      if (!ds) return null;
      try {
        if (ds.includes('-')) { const [dp] = ds.split(' '); const [a, m] = dp.split('-'); return `${m}/${a.slice(2)}`; }
        if (ds.includes('/')) { const [dp] = ds.split(' '); const parts = dp.split('/'); return `${parts[1]}/${parts[2].slice(2)}`; }
      } catch { return null; }
      return null;
    }).filter(Boolean))].sort(),
    [empresas]);

  const opcoesProximaEntrega = React.useMemo(() =>
    [...new Set(empresas.map(e => e.proxima_entrega).filter(Boolean))].sort(),
    [empresas]);

  const opcoesRegime = React.useMemo(() =>
    [...new Set(empresas.map(e => e.regime).filter(Boolean))].sort(),
    [empresas]);

  const opcoesStatusRelatorio = ['Em Dia', 'Pendente', 'Sem envio'];

  const opcoesTipoEntrega = React.useMemo(() =>
    [...new Set(empresas.map(e => e.tipo_entrega).filter(Boolean))].sort(),
    [empresas]);

  const opcoesStatusContabil = React.useMemo(() =>
    [...new Set(empresas.map(e => {
      const s = e.Status_contabil;
      if (!s) return null;
      return s.includes('(') ? s.split('(')[0].trim() : s;
    }).filter(v => v && v !== 'Não definido'))].sort(),
    [empresas]);

  // Função para formatar a data para competência
  const formatarCompetencia = (dataString) => {
    if (!dataString) return '-';
    
    try {
      if (dataString.includes('-')) {
        const [dataPart] = dataString.split(' ');
        const [ano, mes] = dataPart.split('-');
        return `${mes}/${ano.slice(2)}`;
      }
      
      if (dataString.includes('/')) {
        const [dataPart] = dataString.split(' ');
        const [dia, mes, ano] = dataPart.split('/');
        return `${mes}/${ano.slice(2)}`;
      }
      
      return dataString;
    } catch (e) {
      console.error("Erro ao formatar data:", e);
      return dataString;
    }
  };

  // Carregar empresas
const carregarEmpresas = useCallback(() => {
  setCarregando(true);
  setMensagem('');
  const accessToken = localStorage.getItem('access');

  return axios
    .get(`${process.env.REACT_APP_API_BASE}/api/empresas-contabil/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        const empresasCarregadas = res.data.empresas || [];
        
        // console.log('Total de empresas carregadas:', empresasCarregadas.length);
        
        empresasCarregadas.forEach(emp => {
          if (emp.dt) {
            emp.dt = parseInt(emp.dt, 10);
          }
        });
        const operadoresUnicos = [...new Set(empresasCarregadas.map(emp => emp.operador).filter(Boolean))].sort();
        setOperadoresUnicos(operadoresUnicos);
        setEmpresas(empresasCarregadas);
        setCarregando(false);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao carregar empresas';
        setMensagem(`Erro: ${errorMsg}`);
        setCarregando(false);
      });
  }, []);

useEffect(() => {
  if (!acessoNegado && !carregandoAcesso) {
    carregarEmpresas().then(() => {
      // VERIFICAR SE VEIO DO CADASTRO NOTION
      const clienteNotion = localStorage.getItem('editar_cliente_notion');
      if (clienteNotion) {
        const { numero_dominio } = JSON.parse(clienteNotion);
        localStorage.removeItem('editar_cliente_notion');
        
        // Pequeno delay para garantir que as empresas já carregaram
        setTimeout(() => {
          const accessToken = localStorage.getItem('access');
          axios
            .get(`${process.env.REACT_APP_API_BASE}/api/detalhes-empresa/${numero_dominio}/`, {
              headers: { Authorization: `Bearer ${accessToken}` }
            })
            .then((res) => {
              setDetalhesEmpresa(res.data.empresa);
              setDetalhesEditaveis(res.data.empresa);
              setNotasGerenciais(res.data.empresa.notas_gerenciais || []);
              setNotaForm({ id: null, titulo: '', descricao: '', link: '' });
              setModoEdicao(true); // JÁ ABRE EM MODO EDIÇÃO
              setMostrarModalDetalhes(true);
            })
            .catch(() => {});
        }, 1000);
      }
    });
  }
}, [carregarEmpresas, acessoNegado, carregandoAcesso]);
  // Função para carregar histórico de entregas
  const carregarHistorico = () => {
    setHistoricoCarregando(true);
    const accessToken = localStorage.getItem('access');

    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/historico-contabil/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        setHistoricoEntregas(res.data.historico || []);
        setHistoricoCarregando(false);
        setMostrarModalHistorico(true);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao carregar histórico';
        setMensagem(`Erro: ${errorMsg}`);
        setHistoricoCarregando(false);
      });
  };

  // Função para gerar próximas competências
  const gerarProximasCompetencias = (ultimaEntrega) => {
    const competencias = [];
    
    try {
      if (!ultimaEntrega) return competencias;
      
      let mes, ano;
      
      if (ultimaEntrega.includes('/') && ultimaEntrega.length === 5) {
        const [mesStr, anoStr] = ultimaEntrega.split('/');
        mes = parseInt(mesStr);
        ano = parseInt("20" + anoStr);
      }
      else if (ultimaEntrega.includes('-')) {
        const [dataPart] = ultimaEntrega.split(' ');
        const [anoStr, mesStr] = dataPart.split('-');
        mes = parseInt(mesStr);
        ano = parseInt(anoStr);
      }
      else if (ultimaEntrega.includes('/') && ultimaEntrega.includes(' ')) {
        const [dataPart] = ultimaEntrega.split(' ');
        const [dia, mesStr, anoStr] = dataPart.split('/');
        mes = parseInt(mesStr);
        ano = parseInt(anoStr);
      }
      else {
        return competencias;
      }
      
      mes = mes + 1;
      if (mes > 12) {
        mes = 1;
        ano += 1;
      }
      
      for (let i = 0; i < 12; i++) {
        const novoMes = ((mes - 1 + i) % 12) + 1;
        const novoAno = ano + Math.floor((mes - 1 + i) / 12);
        const competencia = `${novoMes.toString().padStart(2, '0')}/${novoAno.toString().slice(-2)}`;
        competencias.push(competencia);
      }
    } catch (e) {
      console.error("Erro ao gerar competências:", e);
    }
    
    return competencias;
  };

  const handleCheckbox = (numero_dominio) => {
    setMostrarSomentesSelecionadas(false);
    setSelecionadas((prev) =>
      prev.includes(numero_dominio)
        ? prev.filter((item) => item !== numero_dominio)
        : [...prev, numero_dominio]
    );
  };

  const selecionarTodas = () => {
    setMostrarSomentesSelecionadas(false);
    if (selecionadas.length === empresasFiltradas.length) {
      setSelecionadas([]);
    } else {
      setSelecionadas(empresasFiltradas.map((emp) => emp.numero_dominio));
    }
  };

  // Função para abrir modal de entrega
  const abrirModalEntrega = (empresa) => {
    setEmpresaSelecionada(empresa);
    
    let ultimaEntregaFormatada = '';
    
    if (empresa.ultima_entrega) {
      ultimaEntregaFormatada = formatarCompetencia(empresa.ultima_entrega);
    }
    
    const competencias = gerarProximasCompetencias(ultimaEntregaFormatada);
    setProximasCompetencias(competencias);
    setCompetenciaSelecionada(competencias[0] || '');
    
    const estaAtrasada = empresa.Status_contabil && empresa.Status_contabil.toLowerCase().includes('atrasado');
    
    if (estaAtrasada) {
      setMostrarModalEntregaAtrasada(true);
    } else {
      setMostrarModalEntrega(true);
    }
  };

  // Função para realizar a entrega
  const realizarEntrega = () => {
    if (!empresaSelecionada || !competenciaSelecionada) {
      return;
    }

    setEntregaCarregando(true);
    const accessToken = localStorage.getItem('access');

    const [mes, anoAbreviado] = competenciaSelecionada.split('/');
    const ano = `20${anoAbreviado}`;
    const dia = empresaSelecionada.dt ? Math.floor(empresaSelecionada.dt) : 30;
    const novaDataEntrega = `${dia.toString().padStart(2, '0')}/${mes}/${ano}`;

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/registrar-entrega/`,
        {
          numero_dominio: empresaSelecionada.numero_dominio,
          nova_data_entrega: novaDataEntrega,
          competencia_entregue: competenciaSelecionada,
          operador: username
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then(() => {
        setMensagem(`Entrega registrada com sucesso para a competência ${competenciaSelecionada}`);
        setMostrarModalEntrega(false);
        setEntregaCarregando(false);
        carregarEmpresas();
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao registrar entrega';
        setMensagem(`Erro: ${errorMsg}`);
        setEntregaCarregando(false);
      });
  };

  // Função para realizar entrega parcial
  // Entrega parcial dentro do prazo: não é atraso, mas a origem do que ficou
  // faltando (nosso gargalo × cliente/terceiro) continua obrigatória.
  const realizarEntregaParcial = () => {
    if (!origemAtraso) {
      setMensagem('Selecione a origem da entrega parcial: Interno ou Externo.');
      return;
    }
    if (!empresaSelecionada || !competenciaSelecionada || !textoEntregaParcial.trim()) {
      setMensagem('Por favor, preencha o campo de observação para a entrega parcial.');
      return;
    }

    setEntregaCarregando(true);
    const accessToken = localStorage.getItem('access');

    const [mes, anoAbreviado] = competenciaSelecionada.split('/');
    const ano = `20${anoAbreviado}`;
    const dia = empresaSelecionada.dt ? Math.floor(empresaSelecionada.dt) : 30;
    const novaDataEntrega = `${dia.toString().padStart(2, '0')}/${mes}/${ano}`;

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/registrar-entrega-parcial/`,
        {
          numero_dominio: empresaSelecionada.numero_dominio,
          nova_data_entrega: novaDataEntrega,
          texto_entrega_parcial: textoEntregaParcial.trim(),
          origem_atraso: origemAtraso,
          competencia_entregue: competenciaSelecionada,
          operador: username
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then(() => {
        setMensagem(`Entrega parcial registrada com sucesso para a competência ${competenciaSelecionada}`);
        setMostrarModalEntregaParcial(false);
        setMostrarModalEntrega(false);
        setEntregaCarregando(false);
        setTextoEntregaParcial('');
        setOrigemAtraso('');
        carregarEmpresas();
        verificarPendenciasUsuario();
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao registrar entrega parcial';
        setMensagem(`Erro: ${errorMsg}`);
        setEntregaCarregando(false);
      });
  };

  // Função para realizar entrega atrasada
  const realizarEntregaAtrasada = () => {
    if (!origemAtraso) {
      setMensagem('Selecione a origem do atraso: Interno ou Externo.');
      return;
    }
    if (!empresaSelecionada || !competenciaSelecionada || !textoEntregaAtrasada.trim()) {
      setMensagem('Por favor, preencha o campo de observação para a entrega atrasada.');
      return;
    }

    setEntregaCarregando(true);
    const accessToken = localStorage.getItem('access');

    const [mes, anoAbreviado] = competenciaSelecionada.split('/');
    const ano = `20${anoAbreviado}`;
    const dia = empresaSelecionada.dt ? Math.floor(empresaSelecionada.dt) : 30;
    const novaDataEntrega = `${dia.toString().padStart(2, '0')}/${mes}/${ano}`;

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/registrar-entrega-atrasada/`,
        {
          numero_dominio: empresaSelecionada.numero_dominio,
          nova_data_entrega: novaDataEntrega,
          texto_entrega_atrasada: textoEntregaAtrasada.trim(),
          origem_atraso: origemAtraso,
          competencia_entregue: competenciaSelecionada,
          operador: username
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then(() => {
        setMensagem(`Entrega atrasada registrada com sucesso para a competência ${competenciaSelecionada}`);
        setMostrarModalEntregaAtrasada(false);
        setEntregaCarregando(false);
        setTextoEntregaAtrasada('');
        setOrigemAtraso('');
        carregarEmpresas();
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao registrar entrega atrasada';
        setMensagem(`Erro: ${errorMsg}`);
        setEntregaCarregando(false);
      });
  };

  // FUNÇÃO PARA REALIZAR ENTREGA ATRASADA PARCIAL
  const realizarEntregaAtrasadaParcial = () => {
    if (!origemAtraso) {
      setMensagem('Selecione a origem do atraso: Interno ou Externo.');
      return;
    }
    if (!empresaSelecionada || !competenciaSelecionada || !textoEntregaAtrasadaParcial.trim()) {
      setMensagem('Por favor, preencha o campo de observação para a entrega atrasada parcial.');
      return;
    }

    setEntregaCarregando(true);
    const accessToken = localStorage.getItem('access');

    const [mes, anoAbreviado] = competenciaSelecionada.split('/');
    const ano = `20${anoAbreviado}`;
    const dia = empresaSelecionada.dt ? Math.floor(empresaSelecionada.dt) : 30;
    const novaDataEntrega = `${dia.toString().padStart(2, '0')}/${mes}/${ano}`;

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/registrar-entrega-atrasada-parcial/`,
        {
          numero_dominio: empresaSelecionada.numero_dominio,
          nova_data_entrega: novaDataEntrega,
          texto_entrega_atrasada_parcial: textoEntregaAtrasadaParcial.trim(),
          origem_atraso: origemAtraso,
          competencia_entregue: competenciaSelecionada,
          operador: username
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then(() => {
        setMensagem(`Entrega atrasada parcial registrada com sucesso para a competência ${competenciaSelecionada}`);
        setMostrarModalEntregaAtrasadaParcial(false);
        setMostrarModalEntregaAtrasada(false);
        setEntregaCarregando(false);
        setTextoEntregaAtrasadaParcial('');
        setOrigemAtraso('');
        carregarEmpresas();
        verificarPendenciasUsuario();
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao registrar entrega atrasada parcial';
        setMensagem(`Erro: ${errorMsg}`);
        setEntregaCarregando(false);
      });
  };

  const inativarCliente = async () => {
    if (!detalhesEmpresa || !temDominio(detalhesEmpresa.numero_dominio)) {
      setMensagem('Erro: Dados do cliente inválidos');
      return;
    }

    setInativandoCliente(true);
    const accessToken = localStorage.getItem('access');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE}/api/inativar-cliente/${detalhesEmpresa.numero_dominio}/`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (response.data.success) {
        setMensagem(`${response.data.mensagem}`);
        setMostrarModalConfirmacao(false);
        setMostrarModalDetalhes(false);
        carregarEmpresas();
        setDetalhesEmpresa(null);
        setDetalhesEditaveis(null);
      } else {
        setMensagem(`Erro: ${response.data.mensagem}`);
      }

      setInativandoCliente(false);
    } catch (error) {
      console.error('Erro ao inativar cliente:', error);
      const errorMsg = error.response?.data?.mensagem || 'Erro ao inativar cliente';
      setMensagem(`${errorMsg}`);
      setInativandoCliente(false);
    }
  };

  const calcularStatusAuditoria = (ultimaEntrega, ultimaAuditoria) => {
    if (!ultimaEntrega) return null;
    if (!ultimaAuditoria) return 'Pendente';
    const mesEntrega   = formatarCompetencia(ultimaEntrega);
    const mesAuditoria = formatarCompetencia(ultimaAuditoria);
    if (!mesEntrega || !mesAuditoria) return 'Pendente';
    return mesEntrega === mesAuditoria ? 'Em Dia' : 'Pendente';
  };

  // Status do Relatório: compara a competência da última entrega com a do
  // último relatório enviado (historico_relatorios_contabil.mes_ano, ex: "Março/2026")
  const mesesPorNome = {
    'janeiro': 1, 'fevereiro': 2, 'marco': 3, 'março': 3, 'abril': 4,
    'maio': 5, 'junho': 6, 'julho': 7, 'agosto': 8, 'setembro': 9,
    'outubro': 10, 'novembro': 11, 'dezembro': 12
  };
  const calcularStatusRelatorio = (ultimaEntrega, ultimoRelatorioMesAno, tipoEntrega) => {
    if (!ultimaEntrega) return null;

    // O último relatório enviado corresponde à competência da última entrega?
    const relatorioCorresponde = (() => {
      if (!ultimoRelatorioMesAno) return false;

      // Última entrega → "MM/YY"
      const compEntrega = formatarCompetencia(ultimaEntrega);
      if (!compEntrega || compEntrega === '-' || !compEntrega.includes('/')) return false;
      const [mesEnt, anoEnt] = compEntrega.split('/');

      // Relatório → aceita "05/2026", "05/26" ou "Maio/2026"
      const partes = String(ultimoRelatorioMesAno).split('/');
      if (partes.length !== 2) return false;
      const p0 = partes[0].trim();
      const mesRel = /^\d+$/.test(p0)
        ? parseInt(p0, 10)                       // formato numérico (05)
        : mesesPorNome[p0.toLowerCase()];        // formato por extenso (Maio)
      if (!mesRel) return false;
      const mesRelStr = mesRel.toString().padStart(2, '0');
      const anoRelStr = partes[1].trim().slice(-2);

      return mesRelStr === mesEnt && anoRelStr === anoEnt;
    })();

    if (relatorioCorresponde) return 'Em Dia';

    // Clientes ANUAIS: a obrigação de relatório nasce com a entrega anual e é
    // cobrada nos 90 dias seguintes a ela. Fora dessa janela (a próxima entrega
    // é só daqui a ~1 ano), o cliente fica Em Dia mesmo sem relatório enviado.
    if ((tipoEntrega || '').trim().toLowerCase() === 'anual') {
      const dataEntrega = converterDataParaComparacao(ultimaEntrega);
      const diasDesdeEntrega = (new Date() - dataEntrega) / (1000 * 60 * 60 * 24);
      return diasDesdeEntrega <= 90 ? 'Pendente' : 'Em Dia';
    }

    return 'Pendente';
  };

  // Formata a data de envio do relatório ("2026-06-19 14:13:49" → "19/06/2026 14:13")
  const formatarDataEnvio = (valor) => {
    if (!valor) return null;
    const [dataPart, horaPart = ''] = String(valor).split(' ');
    if (dataPart.includes('-')) {
      const [ano, mes, dia] = dataPart.split('-');
      const hm = horaPart.slice(0, 5);
      return `${dia}/${mes}/${ano}${hm ? ' ' + hm : ''}`;
    }
    return String(valor);
  };

  // Monta a explicação de POR QUE o Status Relatório está Em Dia/Pendente
  const explicarStatusRelatorio = (empresa) => {
    const status = calcularStatusRelatorio(empresa.ultima_entrega, empresa.ultimo_relatorio_mes_ano, empresa.tipo_entrega);
    const compEntrega = empresa.ultima_entrega ? formatarCompetencia(empresa.ultima_entrega) : null;
    const ehAnual = (empresa.tipo_entrega || '').trim().toLowerCase() === 'anual';
    const temRelatorio = !!empresa.ultimo_relatorio_mes_ano;
    // Sem considerar a regra do anual: o relatório bate com a última entrega?
    const corresponde = calcularStatusRelatorio(empresa.ultima_entrega, empresa.ultimo_relatorio_mes_ano, '') === 'Em Dia';
    const diasDesdeEntrega = empresa.ultima_entrega
      ? Math.floor((new Date() - converterDataParaComparacao(empresa.ultima_entrega)) / (1000 * 60 * 60 * 24))
      : null;

    if (!status) {
      return { status, motivo: 'Esta empresa não tem última entrega registrada, então o status do relatório não se aplica.' };
    }

    if (status === 'Em Dia') {
      if (corresponde) {
        return {
          status,
          motivo: `O último relatório enviado (competência ${empresa.ultimo_relatorio_mes_ano}) corresponde à última entrega registrada (${compEntrega}).`
        };
      }
      // Em Dia pela regra do cliente ANUAL fora da janela de cobrança
      return {
        status,
        motivo: `Cliente com entrega ANUAL. A última entrega registrada é da competência ${compEntrega} e `
          + (temRelatorio
            ? `o último relatório enviado foi de outra competência (${empresa.ultimo_relatorio_mes_ano}). `
            : 'nenhum relatório foi enviado para ela. ')
          + `Como essa competência encerrou há ${diasDesdeEntrega} dias — mais que a janela de cobrança de 90 dias — o sistema `
          + 'não cobra mais esse relatório antigo e considera o cliente Em Dia. A cobrança volta quando a próxima '
          + `entrega anual for registrada${empresa.proxima_entrega ? ` (prevista para ${empresa.proxima_entrega})` : ''}.`
      };
    }

    // Pendente
    if (ehAnual) {
      return {
        status,
        motivo: `Cliente com entrega ANUAL. A entrega da competência ${compEntrega} é recente `
          + `(a competência encerrou há ${diasDesdeEntrega} dias) e o relatório dela ainda não foi enviado. `
          + 'O sistema cobra o relatório da entrega anual nos 90 dias seguintes ao fim da competência.'
      };
    }
    return {
      status,
      motivo: temRelatorio
        ? `O último relatório enviado é da competência ${empresa.ultimo_relatorio_mes_ano}, mas a última entrega registrada é ${compEntrega}. Falta enviar o relatório dessa competência.`
        : `Nenhum relatório foi enviado ainda e a última entrega registrada é ${compEntrega}. Falta enviar o relatório dessa competência.`
    };
  };

  // Abre o modal com a data do último envio de relatório da empresa
  const mostrarUltimoEnvioRelatorio = (empresa) => {
    const { status, motivo } = explicarStatusRelatorio(empresa);
    setModalRelatorioInfo({
      empresa: empresa.empresa,
      dataEnvio: formatarDataEnvio(empresa.ultimo_relatorio_data_envio),
      mesAno: empresa.ultimo_relatorio_mes_ano,
      tipoEntrega: empresa.tipo_entrega,
      status,
      motivo
    });
  };

  const abrirModalAuditoria = (empresa) => {
    localStorage.setItem('auditoria_empresa', JSON.stringify({
      numero_dominio: empresa.numero_dominio,
      nome_empresa:   empresa.empresa,
      ultima_entrega: empresa.ultima_entrega,
    }));
    window.location.href = '/auditoria-balancete';
  };

  // Filtro e ordenação
const empresasFiltradas = empresas
  .filter((emp) => {
    if (mostrarSomentesSelecionadas && selecionadas.length > 0 && !selecionadas.includes(emp.numero_dominio)) return false;
    if (filtroBoletim && !filtroBoletim.dominios.has(String(emp.numero_dominio ?? '').trim())) return false;

    return Object.entries(filtros).every(([campo, valorFiltro]) => {
      if (Array.isArray(valorFiltro)) {
        if (valorFiltro.length === 0) return true;

        if (campo === 'drive_cliente') {
          const temDrive = emp.drive_cliente && emp.drive_cliente !== '-' && emp.drive_cliente.trim() !== '';
          return valorFiltro.some(v => v === 'Com Drive' ? temDrive : !temDrive);
        }

        if (campo === 'ultima_entrega') {
          const ds = emp.ultima_entrega;
          if (!ds) return false;
          let fmt = '';
          try {
            if (ds.includes('-')) { const [dp] = ds.split(' '); const [a, m] = dp.split('-'); fmt = `${m}/${a.slice(2)}`; }
            else if (ds.includes('/')) { const [dp] = ds.split(' '); const parts = dp.split('/'); fmt = `${parts[1]}/${parts[2].slice(2)}`; }
          } catch { return false; }
          return valorFiltro.includes(fmt);
        }

        if (campo === 'status_relatorio') {
          const st = calcularStatusRelatorio(emp.ultima_entrega, emp.ultimo_relatorio_mes_ano, emp.tipo_entrega) || 'Sem envio';
          return valorFiltro.includes(st);
        }

        const valorEmpresa = emp[campo] ? emp[campo].toString() : '';
        return valorFiltro.some(v => valorEmpresa.toLowerCase().includes(v.toLowerCase()));
      }

      if (!valorFiltro) return true;
      const valorEmpresa = emp[campo] ? emp[campo].toString().toLowerCase() : '';
      return valorEmpresa.includes(valorFiltro.toLowerCase());
    });
  })


.sort((a, b) => {
  // ORDENAR POR ÚLTIMA ENTREGA
  if (colunaOrdenacao === 'ultima_entrega') {
    // Trata valores vazios - eles sempre vão pro final
    if (!a.ultima_entrega && !b.ultima_entrega) return 0;
    if (!a.ultima_entrega) return 1; // Vazio vai pro final
    if (!b.ultima_entrega) return -1; // Vazio vai pro final
    
    // Converte as datas no formato MM/YY ou DD/MM/YYYY para Date
    const dataA = converterDataParaComparacao(a.ultima_entrega);
    const dataB = converterDataParaComparacao(b.ultima_entrega);
    
    // Ordena conforme a ordem escolhida
    if (ordemUltimaEntrega === 'desc') {
      // DESC: Mais recente primeiro (12/25 → 11/25 → 10/25 → 09/25...)
      return dataB - dataA;
    } else {
      // ASC: Mais antigo primeiro (09/25 → 10/25 → 11/25 → 12/25...)
      return dataA - dataB;
    }
  }
  
  // ORDENAR POR EMPRESA (A a Z / Z a A)
  if (colunaOrdenacao === 'empresa') {
    const cmp = (a.empresa || '').localeCompare(b.empresa || '', 'pt-BR', { sensitivity: 'base' });
    return ordemEmpresa === 'asc' ? cmp : -cmp;
  }

  // ORDENAR POR PRÓXIMA ENTREGA (padrão)
  const dataA = converterDataParaComparacao(a.proxima_entrega);
  const dataB = converterDataParaComparacao(b.proxima_entrega);
  return dataA - dataB; // Sempre crescente para próxima entrega
})





  // Filtro para o histórico
  const historicoFiltrado = historicoEntregas.filter((item) => {
    if (!filtroHistorico) return true;
    
    const filtroLower = filtroHistorico.toLowerCase();
    return (
      (item.empresa && item.empresa.toLowerCase().includes(filtroLower)) ||
      (item.entregue && item.entregue.toLowerCase().includes(filtroLower)) ||
      (item.numero_dominio && item.numero_dominio.toString().includes(filtroLower)) ||
      (item.texto_livre && item.texto_livre.toLowerCase().includes(filtroLower)) ||
      (item.tipo_entrega && item.tipo_entrega.toLowerCase().includes(filtroLower)) ||
      (item.operador && item.operador.toLowerCase().includes(filtroLower)) ||
      (item.status_entrega && item.status_entrega.toLowerCase().includes(filtroLower))
    );
  });

  // Dados para o gráfico de pizza
  const desempenhoOperador = React.useMemo(() => {
    if (!filtros.operador.length) return [];

    const dados = {};
    empresasFiltradas
      .filter(emp => filtros.operador.includes(emp.operador))
      .forEach(emp => {
        const status = normalizarStatus(emp.Status_contabil);
        dados[status] = (dados[status] || 0) + 1;
      });

    return Object.entries(dados).map(([status, total]) => ({
      name: status,
      value: total
    }));
  }, [empresasFiltradas, filtros.operador]);

  // Função para agrupar as próximas entregas por prazos
  const calcularEntregasPorPrazo = React.useMemo(() => {
    if (!empresasFiltradas.length || !filtros.operador.length) return [];

    const empresasDoOperador = empresasFiltradas.filter(emp => filtros.operador.includes(emp.operador));
    
    const categorias = [
      { label: "Atrasadas", min: -999, max: -1, color: "#dc3545" },
      { label: "Hoje", min: 0, max: 0, color: "#ffc107" },
      { label: "7 dias", min: 1, max: 7, color: "#17a2b8" },
      { label: "15 dias", min: 8, max: 15, color: "#28a745" },
      { label: "30 dias", min: 16, max: 30, color: "#6610f2" },
      { label: "+30 dias", min: 31, max: 999, color: "#6c757d" }
    ];
    
    const contadores = categorias.map(cat => ({
      name: cat.label,
      value: 0,
      color: cat.color
    }));
    
    const calcularDiasRestantes = (proximaEntrega) => {
      if (!proximaEntrega || proximaEntrega === '-') return null;
      
      try {
        const hoje = new Date();
        hoje.setHours(0, 0, 0, 0);
        
        let dataProxima;
        
        if (proximaEntrega.includes('/')) {
          const partes = proximaEntrega.split('/');
          if (partes.length === 3) {
            const dia = parseInt(partes[0]);
            const mes = parseInt(partes[1]) - 1;
            let ano = parseInt(partes[2]);
            
            if (ano < 100) {
              ano = ano < 50 ? 2000 + ano : 1900 + ano;
            }
            
            dataProxima = new Date(ano, mes, dia);
          }
        }
        
        if (!dataProxima || isNaN(dataProxima.getTime())) {
          return null;
        }
        
        const diffTime = dataProxima.getTime() - hoje.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        return diffDays;
      } catch (e) {
        console.error("Erro ao calcular dias restantes:", e);
        return null;
      }
    };
    
    empresasDoOperador.forEach(empresa => {
      let diasRestantes = null;
      
      if (empresa.Status_contabil) {
        const matchStatus = empresa.Status_contabil.match(/\((\d+)\s*dias?$/i);
        if (matchStatus && matchStatus[1]) {
          diasRestantes = parseInt(matchStatus[1]);
          
          if (empresa.Status_contabil.toLowerCase().includes("atrasado")) {
            diasRestantes = -diasRestantes;
          }
        }
      }
      
      if (diasRestantes === null && empresa.proxima_entrega) {
        diasRestantes = calcularDiasRestantes(empresa.proxima_entrega);
      }
      
      if (diasRestantes === null) {
        return;
      }
      
      for (let i = 0; i < categorias.length; i++) {
        const cat = categorias[i];
        if (diasRestantes >= cat.min && diasRestantes <= cat.max) {
          contadores[i].value++;
          break;
        }
      }
    });
    
    return contadores.filter(item => item.value > 0);
  }, [empresasFiltradas, filtros.operador]);

  const verDetalhesEmpresa = (empresa) => {
    const accessToken = localStorage.getItem('access');
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/detalhes-empresa/${empresa.numero_dominio}/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        setDetalhesEmpresa(res.data.empresa);
        setDetalhesEditaveis(res.data.empresa);
        setNotasGerenciais(res.data.empresa.notas_gerenciais || []);
        setNotaForm({ id: null, titulo: '', descricao: '', link: '' });
        setModoEdicao(false);
        setMostrarModalDetalhes(true);
      })
      .catch(() => alert('Erro ao carregar detalhes da empresa'));
  };
  
  const handleDetalheChange = (campo, valor) => {
    setDetalhesEditaveis(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  const salvarDetalhes = () => {
      if (detalhesEditaveis.numero_dominio !== detalhesEmpresa.numero_dominio) {
    const confirmar = window.confirm(
      'ATENÇÃO: Você está alterando o Número do Domínio.\n' +
      'Isso pode afetar registros históricos.\n' +
      'Tem certeza que deseja continuar?'
    );
    
    if (!confirmar) {
      return;
    }
  }
    setSalvandoDetalhes(true);
    const accessToken = localStorage.getItem('access');

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/atualizar-empresa/${detalhesEmpresa.numero_dominio}/`,
        detalhesEditaveis,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then((res) => {
        setDetalhesEmpresa(res.data.empresa);
        setDetalhesEditaveis(res.data.empresa);
        setModoEdicao(false);
        setSalvandoDetalhes(false);
        setMensagem('Dados da empresa atualizados com sucesso!');
        carregarEmpresas();
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.erro ||
          error.response?.data?.mensagem ||
          error.message ||
          'Erro desconhecido ao atualizar empresa';
        setMensagem(`Erro: ${errorMsg}`);
        setSalvandoDetalhes(false);
      });
  };

  // Buscar (via axios, com token) o conteúdo dos anexos que ainda não têm blob URL em cache
  useEffect(() => {
    const token = localStorage.getItem('access');
    const todosAnexos = notasGerenciais.flatMap(n => n.anexos || []);

    todosAnexos.forEach((anexo) => {
      if (anexoUrls[anexo.id]) return;

      axios
        .get(`${process.env.REACT_APP_API_BASE}/api/anexos-nota-gerencial/${anexo.id}/arquivo/`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        })
        .then((res) => {
          const blobUrl = URL.createObjectURL(res.data);
          setAnexoUrls(prev => ({ ...prev, [anexo.id]: blobUrl }));
        })
        .catch(() => {});
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notasGerenciais]);

  // NOTAS GERENCIAIS — recarregar a lista do servidor
  const recarregarNotasGerenciais = () => {
    if (!detalhesEmpresa || !temDominio(detalhesEmpresa.numero_dominio)) return;
    const accessToken = localStorage.getItem('access');
    axios
      .get(`${process.env.REACT_APP_API_BASE}/api/detalhes-empresa/${detalhesEmpresa.numero_dominio}/`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((res) => {
        setNotasGerenciais(res.data.empresa.notas_gerenciais || []);
      })
      .catch(() => {});
  };

  // "COMO FAZER" — abrir edição, cancelar e salvar
  const abrirEdicaoComoFazer = () => {
    setComoFazerEditavel(detalhesEmpresa?.como_fazer || '');
    setModoEdicaoComoFazer(true);
  };

  const cancelarEdicaoComoFazer = () => {
    setModoEdicaoComoFazer(false);
  };

  const salvarComoFazer = () => {
    if (!detalhesEmpresa || !temDominio(detalhesEmpresa.numero_dominio)) {
      setMensagem('Erro: dados do cliente inválidos');
      return;
    }

    setSalvandoComoFazer(true);
    const accessToken = localStorage.getItem('access');

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/salvar-procedimento-empresa/`,
        {
          numero_dominio: detalhesEmpresa.numero_dominio,
          como_fazer: comoFazerEditavel,
          operador: username
        },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      .then((res) => {
        setMensagem(res.data.mensagem || 'Procedimento salvo com sucesso!');
        setDetalhesEmpresa(prev => ({ ...prev, como_fazer: comoFazerEditavel, como_fazer_operador: username }));
        setModoEdicaoComoFazer(false);
        setSalvandoComoFazer(false);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.mensagem ||
          error.response?.data?.erro ||
          error.message ||
          'Erro desconhecido ao salvar procedimento';
        setMensagem(`Erro: ${errorMsg}`);
        setSalvandoComoFazer(false);
      });
  };

  // Criar (sem id) ou editar (com id) uma nota gerencial
  const salvarNotaGerencial = () => {
    if (!detalhesEmpresa || !temDominio(detalhesEmpresa.numero_dominio)) {
      setMensagem('Erro: dados do cliente inválidos');
      return;
    }
    if (!notaForm.titulo.trim()) {
      setMensagem('Informe o título da nota.');
      return;
    }

    setSalvandoNota(true);
    const accessToken = localStorage.getItem('access');

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/salvar-observacao-gerencial/`,
        {
          id: notaForm.id,
          numero_dominio: detalhesEmpresa.numero_dominio,
          cliente: detalhesEmpresa.empresa,
          titulo: notaForm.titulo.trim(),
          descricao: notaForm.descricao,
          link: (notaForm.link || '').trim(),
          operador: username
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then((res) => {
        setMensagem(res.data.mensagem || 'Nota salva com sucesso!');
        setNotaForm({ id: null, titulo: '', descricao: '', link: '' });
        recarregarNotasGerenciais();
        setSalvandoNota(false);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.mensagem ||
          error.response?.data?.erro ||
          error.message ||
          'Erro desconhecido ao salvar nota gerencial';
        setMensagem(`Erro: ${errorMsg}`);
        setSalvandoNota(false);
      });
  };

  // Carregar uma nota no formulário para edição
  const iniciarEdicaoNota = (nota) => {
    setNotaForm({ id: nota.id, titulo: nota.titulo || '', descricao: nota.descricao || '', link: nota.link || '' });
  };

  // Cancelar edição / limpar formulário
  const cancelarEdicaoNota = () => {
    setNotaForm({ id: null, titulo: '', descricao: '', link: '' });
  };

  // Excluir uma nota gerencial
  const excluirNotaGerencial = (notaId) => {
    if (!window.confirm('Tem certeza que deseja excluir esta nota?')) return;

    setSalvandoNota(true);
    const accessToken = localStorage.getItem('access');

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/excluir-observacao-gerencial/`,
        { id: notaId },
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      )
      .then((res) => {
        setMensagem(res.data.mensagem || 'Nota excluída com sucesso!');
        // Se estava editando a nota excluída, limpa o formulário
        if (notaForm.id === notaId) cancelarEdicaoNota();
        recarregarNotasGerenciais();
        setSalvandoNota(false);
      })
      .catch((error) => {
        const errorMsg =
          error.response?.data?.mensagem ||
          error.response?.data?.erro ||
          error.message ||
          'Erro desconhecido ao excluir nota gerencial';
        setMensagem(`Erro: ${errorMsg}`);
        setSalvandoNota(false);
      });
  };

  // Selecionar arquivo (disparado pelo input escondido) e enviar como anexo da nota ativa
  const handleArquivoNotaSelecionado = (e) => {
    const arquivo = e.target.files[0];
    e.target.value = ''; // permite selecionar o mesmo arquivo de novo depois
    if (!arquivo || !notaAnexoAtivoId) return;

    const TAMANHO_MAXIMO_MB = 10;
    if (arquivo.size > TAMANHO_MAXIMO_MB * 1024 * 1024) {
      setMensagem(`Arquivo muito grande. Máximo ${TAMANHO_MAXIMO_MB}MB.`);
      return;
    }

    setEnviandoAnexoNotaId(notaAnexoAtivoId);
    const accessToken = localStorage.getItem('access');
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    formData.append('operador', username);

    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/notas-gerenciais/${notaAnexoAtivoId}/anexos/`,
        formData,
        {
          headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'multipart/form-data' }
        }
      )
      .then((res) => {
        setMensagem(res.data.mensagem || 'Anexo adicionado com sucesso!');
        recarregarNotasGerenciais();
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.mensagem || error.message || 'Erro ao enviar anexo';
        setMensagem(`Erro: ${errorMsg}`);
      })
      .finally(() => setEnviandoAnexoNotaId(null));
  };

  // Excluir um anexo de nota gerencial
  const excluirAnexoNota = (anexoId) => {
    if (!window.confirm('Tem certeza que deseja excluir este anexo?')) return;

    const accessToken = localStorage.getItem('access');
    axios
      .post(
        `${process.env.REACT_APP_API_BASE}/api/anexos-nota-gerencial/${anexoId}/excluir/`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } }
      )
      .then((res) => {
        setMensagem(res.data.mensagem || 'Anexo excluído com sucesso!');
        recarregarNotasGerenciais();
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.mensagem || error.message || 'Erro ao excluir anexo';
        setMensagem(`Erro: ${errorMsg}`);
      });
  };

  const EXTENSOES_IMAGEM_ANEXO = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

  // LOADING DURANTE VERIFICAÇÃO DE ACESSO
  if (carregandoAcesso) {
    return (
      <div className="container mt-5 text-center">
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
          <div>
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Verificando acesso...</span>
            </div>
            <p className="text-muted">Verificando permissões de acesso...</p>
          </div>
        </div>
      </div>
    );
  }

  // TELA DE ACESSO NEGADO
  if (acessoNegado) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-danger" role="alert">
          <i className="fas fa-lock fa-3x mb-3"></i>
          <h2>Acesso Negado</h2>
          <p className="mb-3">
            Você não tem permissão para acessar a área de Contabilidade.
          </p>
          <div className="text-muted mb-3">
            <small>
              <i className="fas fa-user me-2"></i>
              Usuário: <strong>{dadosUsuario?.username || 'Não identificado'}</strong>
            </small>
            <br />
            <small>
              <i className="fas fa-users me-2"></i>
              Grupo: <strong>{dadosUsuario?.grupo || 'Não definido'}</strong>
            </small>
          </div>
          <button 
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.href = '/home'}
          >
            <i className="fas fa-home me-2"></i>
            Voltar para página inicial
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="contabilidade-page">
      {/* COMPONENTE DE NOTIFICAÇÃO DE CLIENTES NOVOS */}
      <NotificationModal />
      <NotificationAtraso10Dias username={username} />
      {/* classificação retroativa INTERNO/EXTERNO: é só um clique, vem primeiro */}
      <NotificationOrigemAtraso username={username} />
      <NotificationRelatorioPendente username={username} />
      <NotificationPrevisaoSLA username={username} />

      <div className="container mt-5 shadow p-4 rounded bg-white">
        {/* Cabeçalho */}
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <i className="fas fa-file-invoice header-icon me-2"></i>
            <h2 className="titulo-pagina m-0">
              Olá, {carregandoAcesso ? (
                <span className="text-muted">
                  <i className="fas fa-spinner fa-spin me-1"></i>
                  carregando...
                </span>
              ) : (
                username
              )}
            </h2>
          </div>
        </div>

        {/* Mensagens agora são exibidas como toast (react-toastify) */}

        {/* Filtro do Operador e Botões */}
        <div className="row mb-2">
          <div className="col-md-3">
            <label className="form-label fw-bold">Operador</label>
            <MultiSelectDropdown
              options={operadoresUnicos}
              selected={filtros.operador}
              onChange={(vals) => setFiltros(prev => ({ ...prev, operador: vals }))}
              placeholder="Todos Operadores"
            />
          </div>
          <div className="col-md-9 d-flex align-items-end gap-2 flex-wrap">
            <button
              className="btn btn-outline-primary"
              onClick={carregarHistorico}
              disabled={historicoCarregando}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
            >
              {historicoCarregando ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Carregando...
                </>
              ) : (
                <>
                  <i className="fas fa-history me-2"></i>
                  Histórico
                </>
              )}
            </button>
            
            <button
              className="btn btn-outline-success"
              onClick={() => window.location.href = '/Textolivre'}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
            >
              <i className="fas fa-edit me-2"></i>
              Texto Livre
            </button>

            <button
              className="btn btn-outline-info"
              onClick={() => window.location.href = '/CadastrarCliente'}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
            >
              <i className="fas fa-user-plus me-2"></i>
              Cadastrar
            </button>
            
            <button
              className="btn btn-success"
              onClick={() => window.location.href = '/Checklist'}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
            >
              <i className="fas fa-envelope me-2"></i>
              Checklist
            </button>
            
            <button
              className="btn btn-dark"
              onClick={() => window.location.href = '/Contabilidade/Operacional'}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
              title="O que precisa de ação hoje: saúde da carteira, operadores, pendências e atrasos"
            >
              <i className="fas fa-clipboard-check me-2"></i>
              Painel Operacional
            </button>

            <button
              className="btn btn-warning"
              onClick={() => window.location.href = '/Pendenciacontabil'}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
            >
              <i className="fas fa-exclamation-triangle me-2"></i>
              Pendências
            </button>
            
            <button
              className="btn btn-primary"
              onClick={() => window.location.href = '/Contagemcontabilidade'}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
            >
              <i className="fas fa-stopwatch me-2"></i>
              Contagem
            </button>  
            <button
              className="btn btn-danger"
              onClick={() => window.location.href = '/Outboardingcontabil'}
              style={{ whiteSpace: 'nowrap', minWidth: '160px' }}
            >
              <i className="fas fa-sign-out-alt me-2"></i>
              Outboarding
            </button>            
          </div>
        </div>

        {/* PRÓXIMAS ENTREGAS EM ALERTA */}
        {(() => {
          const hoje = new Date();
          hoje.setHours(0, 0, 0, 0);

          const parseDatePE = (str) => {
            if (!str || str === '-') return null;
            if (str.includes('/')) {
              const p = str.split('/');
              if (p.length === 3) {
                let ano = parseInt(p[2]);
                if (ano < 100) ano = ano < 50 ? 2000 + ano : 1900 + ano;
                const d = new Date(ano, parseInt(p[1]) - 1, parseInt(p[0]));
                return isNaN(d.getTime()) ? null : d;
              }
            }
            if (str.includes('-')) {
              const d = new Date(str);
              return isNaN(d.getTime()) ? null : d;
            }
            return null;
          };

          const urgentes = [];   // 0–7 dias
          const proximas = [];   // 8–15 dias

          empresasFiltradas.forEach(emp => {
            const data = parseDatePE(emp.proxima_entrega);
            if (!data) return;
            const diff = Math.ceil((data.getTime() - hoje.getTime()) / (1000 * 60 * 60 * 24));
            if (diff < 0) return; // já passou
            if (diff <= 7) urgentes.push({ ...emp, diasRestantes: diff });
            else if (diff <= 15) proximas.push({ ...emp, diasRestantes: diff });
          });

          urgentes.sort((a, b) => a.diasRestantes - b.diasRestantes);
          proximas.sort((a, b) => a.diasRestantes - b.diasRestantes);

          if (urgentes.length === 0 && proximas.length === 0) return null;

          return (
            <div className="mb-4">
              {/* Faixa de resumo */}
              <div className="d-flex align-items-center gap-3 mb-2 flex-wrap">
                <span className="fw-bold" style={{ fontSize: '0.95rem' }}>
                  <i className="fas fa-bell me-2 text-warning"></i>
                  Próximas Entregas em Alerta
                </span>
                {urgentes.length > 0 && (
                  <span className="badge bg-danger fs-6">
                    <i className="fas fa-fire me-1"></i>
                    {urgentes.length} até 7 dias
                  </span>
                )}
                {proximas.length > 0 && (
                  <span className="badge bg-warning text-dark fs-6">
                    <i className="fas fa-clock me-1"></i>
                    {proximas.length} entre 8–15 dias
                  </span>
                )}
              </div>

              {/* Cards urgentes (0–7 dias) */}
              {urgentes.length > 0 && (
                <div className="p-3 rounded border border-danger bg-danger bg-opacity-10 mb-2">
                  <div className="small fw-semibold text-danger mb-2">
                    <i className="fas fa-exclamation-circle me-1"></i>
                    Crítico — Entrega nos próximos 7 dias
                  </div>
                  <div className="d-flex flex-wrap gap-2">
                    {urgentes.map((emp, i) => (
                      <div key={i} className="badge bg-danger d-flex align-items-center gap-1 p-2" style={{ fontSize: '0.8rem', fontWeight: 400 }}>
                        <i className="fas fa-building me-1"></i>
                        <span>{emp.empresa}</span>
                        <span className="ms-1 fw-bold border-start border-light border-opacity-50 ps-1">
                          {emp.diasRestantes === 0 ? 'hoje' : `${emp.diasRestantes}d`}
                        </span>
                        {emp.proxima_entrega && (
                          <span className="ms-1 text-white-50">· {emp.proxima_entrega}</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Cards próximas (8–15 dias) */}
              {proximas.length > 0 && (
                <div className="p-3 rounded border border-warning bg-warning bg-opacity-10">
                  <div className="small fw-semibold text-warning mb-2">
                    <i className="fas fa-clock me-1"></i>
                    Atenção — Entrega entre 8 e 15 dias
                  </div>
                  <div className="d-flex flex-wrap gap-2">
                    {proximas.map((emp, i) => (
                      <div key={i} className="badge bg-warning text-dark d-flex align-items-center gap-1 p-2" style={{ fontSize: '0.8rem', fontWeight: 400 }}>
                        <i className="fas fa-building me-1"></i>
                        <span>{emp.empresa}</span>
                        <span className="ms-1 fw-bold border-start border-dark border-opacity-25 ps-1">
                          {emp.diasRestantes}d
                        </span>
                        {emp.proxima_entrega && (
                          <span className="ms-1" style={{ opacity: 0.7 }}>· {emp.proxima_entrega}</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          );
        })()}

        {/* GRÁFICOS DE DESEMPENHO COM ALERTAS */}
        {filtros.operador.length > 0 && (
          <div className="mb-4 p-3 border rounded bg-light">
            <h5 className="mb-3 text-center">
              <i className="fas fa-chart-pie me-2"></i>
              Desempenho{filtros.operador.length === 1 ? ` do Operador: ${filtros.operador[0]}` : `: ${filtros.operador.join(' + ')}`}
            </h5>
            
            {/* ALERTA DE PENDÊNCIAS */}
            {carregandoPendencias ? (
              <div className="alert alert-info mb-3 d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                <span>Verificando pendências...</span>
              </div>
            ) : totalPendencias > 0 ? (
              <div className="alert alert-warning mb-3 d-flex justify-content-between align-items-center shadow-sm animate__animated animate__headShake">
                <div className="d-flex align-items-center">
                  <i className="fas fa-exclamation-triangle fa-2x me-3 text-warning"></i>
                  <div>
                    <h6 className="mb-1 fw-bold">
                      <i className="fas fa-hourglass-half me-2"></i>
                      Você tem {totalPendencias} {totalPendencias === 1 ? 'pendência contábil' : 'pendências contábeis'}!
                    </h6>
                    <small className="text-muted">
                      <i className="fas fa-info-circle me-1"></i>
                      {totalPendencias === 1 
                        ? 'Entrega parcial aguardando conclusão' 
                        : 'Entregas parciais aguardando conclusão'}
                    </small>
                  </div>
                </div>
                <button 
                  className="btn btn-warning btn-sm fw-bold shadow-sm"
                  onClick={() => window.location.href = '/Pendenciacontabil'}
                  style={{ minWidth: '140px' }}
                >
                  <i className="fas fa-clipboard-list me-2"></i>
                  Ver Pendências
                </button>
              </div>
            ) : totalPendenciasAuditoria === 0 ? (
              // Só parabeniza quando NÃO há pendência contábil NEM de auditoria —
              // auditoria pendente também é uma pendência contábil.
              <div className="alert alert-success mb-3 d-flex align-items-center">
                <i className="fas fa-check-circle fa-2x me-3 text-success"></i>
                <div>
                  <h6 className="mb-1 fw-bold">
                    <i className="fas fa-thumbs-up me-2"></i>
                    Parabéns! Nenhuma pendência contábil
                  </h6>
                  <small className="text-muted">
                    <i className="fas fa-smile me-1"></i>
                    Todas as suas entregas parciais e auditorias foram resolvidas
                  </small>
                </div>
              </div>
            ) : null}
            
            {/* ALERTA DE OUTBOARDING */}
            {carregandoOutboarding ? (
              <div className="alert alert-info mb-3 d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                <span>Verificando seus clientes em outboarding...</span>
              </div>
            ) : totalOutboarding > 0 ? (
              <div className="alert alert-danger mb-3 d-flex flex-column shadow-sm animate__animated animate__headShake">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div className="d-flex align-items-center">
                    <i className="fas fa-sign-out-alt fa-2x me-3 text-danger"></i>
                    <div>
                      <h6 className="mb-1 fw-bold">
                        <i className="fas fa-exclamation-circle me-2"></i>
                        Você tem {totalOutboarding} {totalOutboarding === 1 ? 'cliente' : 'clientes'} em outboarding!
                      </h6>
                      <small className="text-muted">
                        <i className="fas fa-info-circle me-1"></i>
                        {totalOutboarding === 1 
                          ? 'Cliente aguardando finalização do processo de saída' 
                          : 'Clientes aguardando finalização do processo de saída'}
                      </small>
                    </div>
                  </div>
                  <button 
                    className="btn btn-danger btn-sm fw-bold shadow-sm"
                    onClick={() => window.location.href = '/Outboardingcontabil'}
                    style={{ minWidth: '140px' }}
                  >
                    <i className="fas fa-sign-out-alt me-2"></i>
                    Ver Meus Clientes ({totalOutboarding})
                  </button>
                </div>
                
                {/* EXIBIR NOMES DOS CLIENTES EM OUTBOARDING */}
                <div className="mt-2 p-3 bg-light rounded border border-danger">
                  <small className="fw-bold d-block mb-2">
                    <i className="fas fa-list me-2"></i>
                    Clientes em processo de saída:
                  </small>
                  
                  {nomesClientesOutboarding.length > 0 ? (
                    <div className="d-flex flex-column gap-2">
                      {nomesClientesOutboarding.map((nomeCliente, index) => (
                        <div key={index} className="badge bg-white text-danger border border-danger p-2 d-flex align-items-center">
                          <i className="fas fa-building me-2"></i>
                          <span className="fw-semibold">{nomeCliente}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <small className="text-muted">
                      <i className="fas fa-inbox me-2"></i>
                      Nenhum cliente em outboarding no momento
                    </small>
                  )}
                  
                  <small className="text-muted d-block mt-3">
                    <i className="fas fa-user me-1"></i>
                    Operador responsável: <strong>{username}</strong>
                  </small>
                </div>
              </div>
            ) : null}

            {/* ALERTA DE PENDÊNCIAS DE AUDITORIA */}
            {carregandoPendenciasAuditoria ? (
              <div className="alert alert-info mb-3 d-flex align-items-center">
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                <span>Verificando pendências de auditoria...</span>
              </div>
            ) : totalPendenciasAuditoria > 0 ? (
              <div className="alert alert-danger mb-3 d-flex justify-content-between align-items-center shadow-sm animate__animated animate__headShake">
                <div className="d-flex align-items-center">
                  <i className="fas fa-search fa-2x me-3 text-danger"></i>
                  <div>
                    <h6 className="mb-1 fw-bold">
                      <i className="fas fa-exclamation-circle me-2"></i>
                      Você tem {totalPendenciasAuditoria} {totalPendenciasAuditoria === 1 ? 'auditoria pendente' : 'auditorias pendentes'} de resolução!
                    </h6>
                    <small className="text-muted">
                      <i className="fas fa-info-circle me-1"></i>
                      {totalPendenciasAuditoria === 1
                        ? 'Auditoria das suas empresas com apontamentos aguardando resolução'
                        : 'Auditorias das suas empresas com apontamentos aguardando resolução'}
                    </small>
                  </div>
                </div>
                <button
                  className="btn btn-danger btn-sm fw-bold shadow-sm"
                  onClick={() => window.location.href = '/historico-auditoria'}
                  style={{ minWidth: '160px' }}
                >
                  <i className="fas fa-clipboard-check me-2"></i>
                  Ver Auditorias ({totalPendenciasAuditoria})
                </button>
              </div>
            ) : null}

            <div className="row">
              {/* Gráfico de Pizza - Status */}
              <div className="col-md-6">
                <h6 className="text-center mb-2">Distribuição de Status</h6>
                {desempenhoOperador.length > 0 ? (
                  <ResponsiveContainer width="100%" height={350}>
                    <PieChart>
                      <Pie
                        data={desempenhoOperador}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        outerRadius={120}
                        innerRadius={70}
                        paddingAngle={4}
                        cornerRadius={10}
                        isAnimationActive={true}
                        label={({ name, percent }) =>
                          `${name}: ${(percent * 100).toFixed(0)}%`
                        }
                        stroke="#fff"
                      >
                        {desempenhoOperador.map((entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={
                              entry.name === "Concluído" || entry.name === "Em Dia"
                                ? "#28a745"
                                : entry.name === "Pendente" || entry.name === "Aguardando"
                                ? "#ffc107"
                                : entry.name === "Atrasado"
                                ? "#dc3545"
                                : "#6c757d"
                            }
                          />
                        ))}
                      </Pie>
                      <Tooltip
                        contentStyle={{
                          backgroundColor: "#c2e03bff",
                          border: "none",
                          borderRadius: "8px",
                          color: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                        }}
                        formatter={(value, name) => [`${value}`, name]}
                      />
                      <Legend
                        verticalAlign="bottom"
                        iconSize={14}
                        wrapperStyle={{
                          marginTop: "20px",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      />
                    </PieChart>
                  </ResponsiveContainer>
                ) : (
                  <p className="text-muted mt-4 text-center">Nenhum dado disponível para este operador.</p>
                )}
              </div>
              
              {/* Gráfico de Colunas - Prazos de Entregas */}
              <div className="col-md-6">
                <h6 className="text-center mb-2">Próximas Entregas por Prazo</h6>
                {calcularEntregasPorPrazo.length > 0 ? (
                  <ResponsiveContainer width="100%" height={350}>
                    <BarChart
                      data={calcularEntregasPorPrazo}
                      margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="name" />
                      <YAxis allowDecimals={false} />
                      <RechartsTooltip
                        contentStyle={{
                          backgroundColor: "#c1db2eff",
                          border: "none",
                          borderRadius: "8px",
                          color: "#fff",
                          boxShadow: "0 2px 8px rgba(214, 162, 66, 0.3)",
                        }}
                        formatter={(value) => [`${value} entregas`, 'Quantidade']}
                      />
                      <Bar dataKey="value" radius={[4, 4, 0, 0]}>
                        {calcularEntregasPorPrazo.map((entry, index) => (
                          <Cell key={`bar-cell-${index}`} fill={entry.color} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                ) : (
                  <p className="text-muted mt-4 text-center">Nenhum prazo de entrega disponível.</p>
                )}
              </div>
            </div>
            
            <div className="row mt-3">
              <div className="col-12">
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  <small className="text-muted">
                    <span className="badge" style={{backgroundColor: "#dc3545"}}></span> Atrasadas
                  </small>
                  <small className="text-muted">
                    <span className="badge" style={{backgroundColor: "#ffc107"}}></span> Hoje
                  </small>
                  <small className="text-muted">
                    <span className="badge" style={{backgroundColor: "#17a2b8"}}></span> Próximos 7 dias
                  </small>
                  <small className="text-muted">
                    <span className="badge" style={{backgroundColor: "#28a745"}}></span> 8-15 dias
                  </small>
                  <small className="text-muted">
                    <span className="badge" style={{backgroundColor: "#6610f2"}}></span> 16-30 dias
                  </small>
                  <small className="text-muted">
                    <span className="badge" style={{backgroundColor: "#6c757d"}}></span> +30 dias
                  </small>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Barra de seleção acima da tabela */}
        {selecionadas.length > 0 && (
          <div className="d-flex align-items-center gap-2 flex-wrap mb-2 p-2 bg-light rounded border">
            <span className="badge bg-primary fs-6">
              <i className="fas fa-check-square me-1"></i>
              {selecionadas.length} selecionada(s)
            </span>
            <button
              className={`btn btn-sm ${mostrarSomentesSelecionadas ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setMostrarSomentesSelecionadas(prev => !prev)}
            >
              <i className="fas fa-filter me-1"></i>
              {mostrarSomentesSelecionadas ? 'Mostrar todas' : 'Ver apenas selecionadas'}
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => { setSelecionadas([]); setMostrarSomentesSelecionadas(false); }}
            >
              <i className="fas fa-times me-1"></i>
              Limpar seleção
            </button>
          </div>
        )}

        {/* Filtro vindo do link do boletim operacional */}
        {filtroBoletim && !carregando && (
          <div className="alert alert-info d-flex align-items-center justify-content-between py-2 mb-2">
            <span>
              <i className="fas fa-filter me-2"></i>
              Mostrando <strong>{empresasFiltradas.length}</strong> empresa(s) do boletim:{' '}
              <strong>{filtroBoletim.titulo}</strong>
            </span>
            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={limparFiltroBoletim}>
              <i className="fas fa-times me-1"></i>Ver todas
            </button>
          </div>
        )}

        {/* Botão de exportação da tabela de clientes */}
        {!carregando && (
          <div className="d-flex justify-content-end mb-2">
            <button
              className="btn btn-sm btn-success"
              onClick={exportarClientesParaExcel}
              disabled={empresasFiltradas.length === 0}
              title="Exportar a tabela de clientes para Excel (respeita os filtros aplicados)"
            >
              <i className="fas fa-file-excel me-2"></i>
              Exportar Excel
            </button>
          </div>
        )}

        {/* Tabela */}
        <div className="table-responsive">
          {carregando ? (
            <div className="text-center mt-4">
              <div className="spinner-border" role="status"></div>
              <p>Carregando empresas...</p>
            </div>
          ) : (
            <>
              <table className="table table-bordered table-hover text-center align-middle fs-6">
                <colgroup>
                  <col style={{ width: "40px" }} />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col />
                  <col style={{ width: "220px" }} />
                </colgroup>
                <thead className="table-light">
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        checked={
                          selecionadas.length === empresasFiltradas.length &&
                          empresasFiltradas.length > 0
                        }
                        onChange={selecionarTodas}
                      />
                    </th>
                    <th>
                      Nº Domínio
                      <MultiSelectDropdown
                        options={opcoesNumeroDominio}
                        selected={filtros.numero_dominio}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, numero_dominio: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    <th>
                      <div className="d-flex align-items-center justify-content-center">
                        Empresa
                        <i
                          className={`fas ${
                            colunaOrdenacao === 'empresa'
                              ? (ordemEmpresa === 'asc' ? 'fa-sort-alpha-down' : 'fa-sort-alpha-up')
                              : 'fa-sort'
                          } ms-2 ${colunaOrdenacao === 'empresa' ? 'text-primary' : 'text-muted'}`}
                          style={{ cursor: 'pointer' }}
                          title={
                            colunaOrdenacao === 'empresa'
                              ? (ordemEmpresa === 'asc' ? 'Ordenando de A a Z (clique para Z a A)' : 'Ordenando de Z a A (clique para A a Z)')
                              : 'Clique para ordenar por empresa (A a Z)'
                          }
                          onClick={() => {
                            if (colunaOrdenacao === 'empresa') {
                              setOrdemEmpresa(prev => (prev === 'asc' ? 'desc' : 'asc'));
                            } else {
                              setColunaOrdenacao('empresa');
                              setOrdemEmpresa('asc');
                            }
                          }}
                        ></i>
                      </div>
                      <input
                        type="text"
                        className="form-control form-control-sm mt-1"
                        placeholder="Filtrar..."
                        value={filtros.empresa}
                        onChange={(e) => setFiltros(prev => ({ ...prev, empresa: e.target.value }))}
                        style={{ fontSize: '0.8rem' }}
                      />
                    </th>
                    <th>
                      Drive Cliente
                      <MultiSelectDropdown
                        options={['Com Drive', 'Sem Drive']}
                        selected={filtros.drive_cliente}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, drive_cliente: vals }))}
                        placeholder="Todos"
                      />
                    </th>


<th>
  <div className="d-flex align-items-center justify-content-center">
    Ultima Entrega
    <i 
      className={`fas ${
        colunaOrdenacao === 'ultima_entrega' 
          ? (ordemUltimaEntrega === 'desc' ? 'fa-sort-amount-down' : 'fa-sort-amount-up')
          : 'fa-sort'
      } ms-2 ${colunaOrdenacao === 'ultima_entrega' ? 'text-primary' : 'text-muted'}`}
      style={{ cursor: 'pointer' }}
      title={
        colunaOrdenacao === 'ultima_entrega' 
          ? (ordemUltimaEntrega === 'desc' 
              ? 'Clique para ordenar do mais antigo ao mais recente' 
              : 'Clique para ordenar do mais recente ao mais antigo')
          : 'Clique para ordenar por esta coluna'
      }
      onClick={() => {
        if (colunaOrdenacao === 'ultima_entrega') {
          // Se já está ordenando por esta coluna, alterna entre desc e asc
          setOrdemUltimaEntrega(prev => prev === 'desc' ? 'asc' : 'desc');
        } else {
          // Se estava ordenando por outra coluna, ativa esta coluna com DESC primeiro
          setColunaOrdenacao('ultima_entrega');
          setOrdemUltimaEntrega('desc'); // COMEÇA COM DESC (mais recente primeiro)
        }
      }}
    ></i>
  </div>
  <MultiSelectDropdown
    options={opcoesUltimaEntrega}
    selected={filtros.ultima_entrega}
    onChange={(vals) => setFiltros(prev => ({ ...prev, ultima_entrega: vals }))}
    placeholder="Todas"
  />
</th>

                        <th>
                          <div className="d-flex align-items-center justify-content-center">
                            Próxima Entrega
                            <i 
                              className={`fas fa-sort-amount-down ms-2 ${colunaOrdenacao === 'proxima_entrega' ? 'text-primary' : 'text-muted'}`}
                              style={{ cursor: 'pointer' }}
                              title={colunaOrdenacao === 'proxima_entrega' ? 'Ordenando por Próxima Entrega (clique em Última Entrega para mudar)' : 'Clique para ordenar por Próxima Entrega'}
                              onClick={() => setColunaOrdenacao('proxima_entrega')}
                            ></i>
                          </div>
                      <MultiSelectDropdown
                        options={opcoesProximaEntrega}
                        selected={filtros.proxima_entrega}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, proxima_entrega: vals }))}
                        placeholder="Todas"
                      />
                    </th>                    
                    <th>
                      Regime
                      <MultiSelectDropdown
                        options={opcoesRegime}
                        selected={filtros.regime}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, regime: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    <th>
                      Operador
                      <MultiSelectDropdown
                        options={operadoresUnicos}
                        selected={filtros.operador}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, operador: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    <th>
                      Status Contábil
                      <MultiSelectDropdown
                        options={opcoesStatusContabil}
                        selected={filtros.Status_contabil}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, Status_contabil: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    {/* COLUNA COMENTADA - reativar quando for usar
                    <th className="text-center">Status Auditoria</th>
                    */}
                    <th className="text-center">
                      Status Relatório
                      <MultiSelectDropdown
                        options={opcoesStatusRelatorio}
                        selected={filtros.status_relatorio}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, status_relatorio: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    <th>
                      Tipo Entrega
                      <MultiSelectDropdown
                        options={opcoesTipoEntrega}
                        selected={filtros.tipo_entrega}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, tipo_entrega: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    <th>
                      Controle Financeiro
                      <MultiSelectDropdown
                        options={controlesFinanceiros}
                        selected={filtros.controle_financeiro}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, controle_financeiro: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    <th>
                      Grupo
                      <MultiSelectDropdown
                        options={gruposDisponiveis}
                        selected={filtros.grupo}
                        onChange={(vals) => setFiltros(prev => ({ ...prev, grupo: vals }))}
                        placeholder="Todos"
                      />
                    </th>
                    <th style={{ width: "220px" }}>
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {empresasFiltradas.map((empresa) => (
                    <tr key={empresa.numero_dominio}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selecionadas.includes(
                            empresa.numero_dominio
                          )}
                          onChange={() =>
                            handleCheckbox(empresa.numero_dominio)
                          }
                        />
                      </td>
                      <td>{empresa.numero_dominio}</td>
                      <td className="text-start">{empresa.empresa}</td>
                      <td>
                        {empresa.drive_cliente && empresa.drive_cliente !== '-' ? (
                          <button
                            className="btn btn-sm btn-outline-success"
                            onClick={() =>
                              window.open(empresa.drive_cliente, '_blank')
                            }
                            title="Abrir Drive"
                          >
                            <i className="fas fa-external-link-alt"></i>
                          </button>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>{empresa.ultima_entrega ? formatarCompetencia(empresa.ultima_entrega) : '-'}</td>
                      <td>{empresa.proxima_entrega || '-'}</td>
                      <td>{empresa.regime || '-'}</td>
                      <td>{empresa.operador || '-'}</td>
                      <td>
                        <span
                          className={`badge ${
                            empresa.Status_contabil === 'Concluído' || empresa.Status_contabil === 'Em Dia'
                              ? 'bg-success'
                              : empresa.Status_contabil === 'Pendente' || empresa.Status_contabil === 'Aguardando'
                              ? 'bg-warning text-dark'
                              : empresa.Status_contabil && empresa.Status_contabil.includes('Atrasado')
                              ? 'bg-danger'
                              : 'bg-success'
                          }`}
                          style={{ 
                            fontSize: '0.8rem',
                            fontWeight: 'light',
                            padding: '0.4em 0.6em'
                          }}
                        >
                          {empresa.Status_contabil || 'Não definido'}
                        </span>
                      </td>
                      {/* COLUNA COMENTADA - reativar quando for usar
                      <td className="text-center">
                        {(() => {
                          const st = calcularStatusAuditoria(empresa.ultima_entrega, empresa.ultima_auditoria);
                          if (!st) return <span className="text-muted small">—</span>;
                          return (
                            <span className={`badge ${st === 'Em Dia' ? 'bg-success' : 'bg-warning text-dark'}`}>
                              {st === 'Em Dia' ? <><i className="fas fa-check me-1"></i>Em Dia</> : <><i className="fas fa-clock me-1"></i>Pendente</>}
                            </span>
                          );
                        })()}
                      </td>
                      */}
                      <td className="text-center">
                        {(() => {
                          const st = calcularStatusRelatorio(empresa.ultima_entrega, empresa.ultimo_relatorio_mes_ano, empresa.tipo_entrega);
                          if (!st) return <span className="text-muted small">—</span>;
                          return (
                            <span
                              className={`badge ${st === 'Em Dia' ? 'bg-success' : 'bg-danger'}`}
                              style={{ cursor: 'pointer' }}
                              title="Clique para ver a data do último envio do relatório"
                              onClick={() => mostrarUltimoEnvioRelatorio(empresa)}
                            >
                              {st === 'Em Dia' ? <><i className="fas fa-check me-1"></i>Em Dia</> : <><i className="fas fa-clock me-1"></i>Pendente</>}
                            </span>
                          );
                        })()}
                      </td>
                      <td>{empresa.tipo_entrega || '-'}</td>
                      <td>{empresa.controle_financeiro || '-'}</td>
                      <td>{empresa.grupo || '-'}</td>
                          {/* Na parte da tabela onde estão as ações (botões) */}
                          <td style={{ width: "220px", padding: "4px" }}>
                            <div
                              style={{
                                display: "flex",
                                gap: "3px",
                                justifyContent: "center",
                                flexWrap: "nowrap",
                                alignItems: "center"
                              }}
                            >
                              <button 
                                className="btn btn-sm btn-info" 
                                style={{ padding: "0.2rem 0.3rem", fontSize: "0.7rem", minWidth: "28px" }}
                                onClick={() => verDetalhesEmpresa(empresa)}
                                title="Ver Detalhes"
                              >
                                <i className="fas fa-eye"></i>
                              </button>
                              
                              <button
                                className="btn btn-sm btn-success"
                                style={{ padding: "0.2rem 0.3rem", fontSize: "0.7rem", minWidth: "28px" }}
                                onClick={() => abrirModalEntrega(empresa)}
                                title="Registrar Entrega"
                              >
                                <i className="fas fa-check-circle"></i>
                              </button>

                              {(empresa.regime || '').trim().toLowerCase() === 'lucro real' && (
                                <button
                                  className="btn btn-sm btn-warning"
                                  style={{ padding: "0.2rem 0.3rem", fontSize: "0.7rem", minWidth: "28px" }}
                                  onClick={() => abrirModalAuditoria(empresa)}
                                  title="Registrar Auditoria"
                                >
                                  <i className="fas fa-search"></i>
                                </button>
                              )}
                              
                              <button 
                                className="btn btn-sm btn-primary" 
                                style={{ padding: "0.2rem 0.3rem", fontSize: "0.7rem", minWidth: "28px" }}
                                onClick={() => {
                                  localStorage.setItem('relatorio_empresa', JSON.stringify({
                                    numero_dominio: empresa.numero_dominio,
                                    nome_empresa: empresa.empresa
                                  }));
                                  window.location.href = '/Relatorio_contabil';
                                }}
                                title="Enviar Relatório"
                              >
                                <i className="fas fa-file-alt"></i>
                              </button>
                              
                              {/* NOVO BOTÃO PARA ATRASOS +10 DIAS */}
                              <button 
                                className="btn btn-sm btn-danger" 
                                style={{ padding: "0.2rem 0.3rem", fontSize: "0.7rem", minWidth: "28px" }}
                                onClick={() => {
                                  localStorage.setItem('atraso_empresa', JSON.stringify({
                                    numero_dominio: empresa.numero_dominio,
                                    nome_empresa: empresa.empresa,
                                    operador: empresa.operador
                                  }));
                                  window.location.href = '/Atrasoatual';
                                }}
                                title="Gerenciar Atrasos Críticos"
                              >
                                <i className="fas fa-exclamation-circle"></i>
                              </button>
                              
                              {(() => {
                                const qtd = pendenciasPorEmpresa[String(empresa.numero_dominio ?? '')] || 0;
                                return (
                                  <button
                                    className={`btn btn-sm ${qtd > 0 ? 'btn-warning' : 'btn-secondary'}`}
                                    style={{ padding: "0.2rem 0.3rem", fontSize: "0.7rem", minWidth: "28px" }}
                                    onClick={() => { window.location.href = '/Pendenciacontabil'; }}
                                    title={qtd > 0
                                      ? `${qtd} pendência${qtd > 1 ? 's' : ''} em aberto (clique para ver)`
                                      : 'Sem pendências em aberto'}
                                  >
                                    <i className="fas fa-exclamation-triangle"></i>
                                  </button>
                                );
                              })()}

                              <button
                                className="btn btn-sm btn-dark"
                                style={{ padding: "0.2rem 0.3rem", fontSize: "0.7rem", minWidth: "28px" }}
                                onClick={() => {
                                  localStorage.setItem('reuniao_cliente', JSON.stringify({
                                    numero_dominio: empresa.numero_dominio,
                                    empresa: empresa.empresa,
                                    operador: empresa.operador,
                                    regime: empresa.regime,
                                    tipo_entrega: empresa.tipo_entrega,
                                    ultima_entrega: empresa.ultima_entrega,
                                    proxima_entrega: empresa.proxima_entrega,
                                    Status_contabil: empresa.Status_contabil,
                                    controle_financeiro: empresa.controle_financeiro,
                                    grupo: empresa.grupo
                                  }));
                                  window.location.href = '/Reunioes';
                                }}
                                title="Iniciar Reunião"
                              >
                                <i className="fas fa-video"></i>
                              </button>
                            </div>
                          </td>
                    </tr> ))}
                </tbody>
              </table>

              <div className="mt-3 text-end">
                <span className="text-muted">
                  Total de registros encontrados: {empresasFiltradas.length}
                </span>
              </div>
            </>
          )}

          {!carregando && empresasFiltradas.length === 0 && (
            <div className="text-center mt-4">
              <p className="text-muted">Nenhuma empresa encontrada.</p>
            </div>
          )}
        </div>
      </div>

      {/* Modal de Detalhes com Edição E DELETAR */}
      {mostrarModalDetalhes && detalhesEmpresa && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-xl" style={{maxWidth: '1400px', width: '95vw'}}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title mb-0 fw-bold">
                  {modoEdicao ? (
                    <>
                      <i className="fas fa-edit me-2"></i>
                      Editar Empresa
                    </>
                  ) : (
                    <>
                      <i className="fas fa-info-circle me-2"></i>
                      Detalhes da Empresa
                    </>
                  )}
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setMostrarModalDetalhes(false)}
                  disabled={salvandoDetalhes || inativandoCliente}
                ></button>
              </div>
              <div className="modal-body">
                {/* Alerta de identificação */}
                <div className="alert alert-info mb-3">
                  <strong>
                    <i className="fas fa-building me-2"></i>
                    {detalhesEmpresa.empresa}
                  </strong>
                  <br />
                  <small>
                    <i className="fas fa-barcode me-2"></i>
                    Domínio: {detalhesEmpresa.numero_dominio}
                  </small>
                </div>

                {/* COMO FAZER — procedimento único da empresa */}
                <div className="card mb-3 border-0 shadow-sm">
                  <div className="card-header py-2 d-flex justify-content-between align-items-center" style={{ backgroundColor: '#1a3a5c', color: '#fff' }}>
                    <strong style={{ fontSize: '0.85rem' }}>
                      <i className="fas fa-list-check me-2"></i>Como Fazer
                    </strong>
                    {!modoEdicaoComoFazer && (
                      <button
                        type="button"
                        className="btn btn-sm btn-light"
                        style={{ padding: '0.1rem 0.5rem', fontSize: '0.75rem' }}
                        onClick={abrirEdicaoComoFazer}
                      >
                        <i className="fas fa-edit me-1"></i>
                        {detalhesEmpresa.como_fazer ? 'Editar' : 'Adicionar'}
                      </button>
                    )}
                  </div>
                  <div className="card-body py-3">
                    {modoEdicaoComoFazer ? (
                      <>
                        <textarea
                          className="form-control form-control-sm"
                          rows="5"
                          placeholder="Descreva o passo a passo / procedimento desta empresa..."
                          value={comoFazerEditavel}
                          onChange={(e) => setComoFazerEditavel(e.target.value)}
                          disabled={salvandoComoFazer}
                          maxLength={10000}
                        />
                        <div className="text-muted text-end" style={{ fontSize: '0.7rem' }}>
                          Restam {(10000 - comoFazerEditavel.length).toLocaleString('pt-BR')} de 10.000 caracteres
                        </div>
                        <div className="text-end mt-2">
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2"
                            onClick={cancelarEdicaoComoFazer}
                            disabled={salvandoComoFazer}
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={salvarComoFazer}
                            disabled={salvandoComoFazer}
                          >
                            {salvandoComoFazer ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Salvando...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-save me-2"></i>
                                Salvar
                              </>
                            )}
                          </button>
                        </div>
                      </>
                    ) : detalhesEmpresa.como_fazer ? (
                      <>
                        <div className="text-muted" style={{ fontSize: '0.85rem', whiteSpace: 'pre-wrap' }}>
                          {detalhesEmpresa.como_fazer}
                        </div>
                        {detalhesEmpresa.como_fazer_operador && (
                          <div className="text-muted mt-2" style={{ fontSize: '0.7rem' }}>
                            <i className="fas fa-user me-1"></i>{detalhesEmpresa.como_fazer_operador}
                          </div>
                        )}
                      </>
                    ) : (
                      <p className="text-muted small mb-0">
                        <i className="fas fa-inbox me-2"></i>
                        Nenhum procedimento cadastrado para este cliente.
                      </p>
                    )}
                  </div>
                </div>

                {/* NOTAS GERENCIAIS */}
                <div className="card mb-3 border-0 shadow-sm">
                  <div className="card-header py-2" style={{ backgroundColor: '#1a3a5c', color: '#fff' }}>
                    <strong style={{ fontSize: '0.85rem' }}>
                      <i className="fas fa-clipboard me-2"></i>Notas Gerenciais
                      {notasGerenciais.length > 0 && (
                        <span className="badge bg-light text-dark ms-2">{notasGerenciais.length}</span>
                      )}
                    </strong>
                  </div>
                  <div className="card-body py-3">
                    {/* Input escondido usado para upload de anexos das notas */}
                    <input
                      type="file"
                      id="input-anexo-nota-gerencial"
                      style={{ display: 'none' }}
                      accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx"
                      onChange={handleArquivoNotaSelecionado}
                    />

                    {/* Lista de notas existentes */}
                    {notasGerenciais.length > 0 ? (
                      <div className="d-flex flex-column gap-2 mb-3">
                        {notasGerenciais.map((nota) => (
                          <div
                            key={nota.id}
                            className={`border rounded p-2 ${notaForm.id === nota.id ? 'border-primary bg-light' : ''}`}
                          >
                            <div className="d-flex justify-content-between align-items-start">
                              <div className="flex-grow-1 me-2">
                                <div className="fw-bold" style={{ fontSize: '0.9rem' }}>
                                  <i className="fas fa-thumbtack me-2 text-primary"></i>
                                  {nota.titulo}
                                </div>
                                {nota.descricao && (
                                  <div className="text-muted mt-1" style={{ fontSize: '0.85rem', whiteSpace: 'pre-wrap' }}>
                                    {nota.descricao}
                                  </div>
                                )}
                                {nota.link && (
                                  <a
                                    href={nota.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-outline-primary mt-1"
                                    style={{ fontSize: '0.72rem', padding: '0.1rem 0.5rem' }}
                                  >
                                    <i className="fas fa-link me-1"></i>Abrir link
                                  </a>
                                )}
                                <div className="text-muted mt-1" style={{ fontSize: '0.7rem' }}>
                                  {nota.operador && (<><i className="fas fa-user me-1"></i>{nota.operador}&nbsp;&nbsp;</>)}
                                  {nota.data_criacao && (<><i className="fas fa-calendar me-1"></i>{nota.data_criacao}</>)}
                                </div>
                              </div>
                              <div className="d-flex gap-1">
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  style={{ padding: '0.15rem 0.4rem', fontSize: '0.75rem' }}
                                  onClick={() => iniciarEdicaoNota(nota)}
                                  disabled={salvandoNota}
                                  title="Editar nota"
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-danger"
                                  style={{ padding: '0.15rem 0.4rem', fontSize: '0.75rem' }}
                                  onClick={() => excluirNotaGerencial(nota.id)}
                                  disabled={salvandoNota}
                                  title="Excluir nota"
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </div>
                            </div>

                            {/* Anexos da nota */}
                            <div className="mt-2 pt-2 border-top d-flex flex-wrap gap-2 align-items-center">
                              {(nota.anexos || []).map((anexo) => {
                                const isImagem = EXTENSOES_IMAGEM_ANEXO.includes((anexo.tipo || '').toLowerCase());
                                const blobUrl = anexoUrls[anexo.id];
                                return (
                                  <div key={anexo.id} className="d-flex align-items-center gap-1" style={{ flex: '0 0 auto' }}>
                                    {blobUrl ? (
                                      <a
                                        href={blobUrl}
                                        target={isImagem ? '_blank' : undefined}
                                        rel="noopener noreferrer"
                                        download={isImagem ? undefined : anexo.nome_original}
                                        title={anexo.nome_original}
                                      >
                                        {isImagem ? (
                                          <img
                                            src={blobUrl}
                                            alt={anexo.nome_original}
                                            style={{ width: 54, height: 54, objectFit: 'cover', borderRadius: '0.375rem', border: '1px solid #dee2e6', display: 'block' }}
                                          />
                                        ) : (
                                          <div
                                            className="d-flex flex-column align-items-center justify-content-center bg-light border rounded"
                                            style={{ width: 54, height: 54, boxSizing: 'border-box' }}
                                          >
                                            <i className="fas fa-file-alt text-secondary" style={{ fontSize: '1.3rem' }}></i>
                                            <span className="text-muted" style={{ fontSize: '0.55rem' }}>.{anexo.tipo}</span>
                                          </div>
                                        )}
                                      </a>
                                    ) : (
                                      <div
                                        className="d-flex align-items-center justify-content-center bg-light border rounded"
                                        style={{ width: 54, height: 54 }}
                                        title={anexo.nome_original}
                                      >
                                        <span className="spinner-border spinner-border-sm text-secondary"></span>
                                      </div>
                                    )}
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-danger"
                                      style={{ width: 22, height: 54, padding: 0, fontSize: '0.75rem', flex: '0 0 auto' }}
                                      onClick={() => excluirAnexoNota(anexo.id)}
                                      title="Excluir anexo"
                                    >
                                      <i className="fas fa-times"></i>
                                    </button>
                                  </div>
                                );
                              })}

                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                style={{ width: 54, height: 54 }}
                                onClick={() => {
                                  setNotaAnexoAtivoId(nota.id);
                                  document.getElementById('input-anexo-nota-gerencial').click();
                                }}
                                disabled={enviandoAnexoNotaId === nota.id}
                                title="Adicionar anexo"
                              >
                                {enviandoAnexoNotaId === nota.id ? (
                                  <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                  <i className="fas fa-paperclip"></i>
                                )}
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-muted small mb-3">
                        <i className="fas fa-inbox me-2"></i>
                        Nenhuma nota gerencial cadastrada para este cliente.
                      </p>
                    )}

                    {/* Formulário de nova nota / edição */}
                    <div className="border-top pt-3">
                      <label className="form-label mb-1 text-muted" style={{ fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                        {notaForm.id ? 'Editar nota' : 'Nova nota'}
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Título da nota"
                        value={notaForm.titulo}
                        onChange={(e) => setNotaForm(prev => ({ ...prev, titulo: e.target.value }))}
                        disabled={salvandoNota}
                        maxLength={255}
                      />
                      <div className="text-muted text-end mb-2" style={{ fontSize: '0.7rem' }}>
                        Restam {255 - notaForm.titulo.length} de 255 caracteres
                      </div>
                      <textarea
                        className="form-control form-control-sm"
                        rows="3"
                        placeholder="Descrição da nota..."
                        value={notaForm.descricao}
                        onChange={(e) => setNotaForm(prev => ({ ...prev, descricao: e.target.value }))}
                        disabled={salvandoNota}
                        maxLength={2000}
                      />
                      <div className="text-muted text-end mb-2" style={{ fontSize: '0.7rem' }}>
                        Restam {(2000 - notaForm.descricao.length).toLocaleString('pt-BR')} de 2.000 caracteres
                      </div>
                      <input
                        type="url"
                        className="form-control form-control-sm"
                        placeholder="Link (opcional) — ex: https://drive.google.com/..."
                        value={notaForm.link}
                        onChange={(e) => setNotaForm(prev => ({ ...prev, link: e.target.value }))}
                        disabled={salvandoNota}
                        maxLength={500}
                      />
                      <div className="text-end mt-2">
                        {notaForm.id && (
                          <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2"
                            onClick={cancelarEdicaoNota}
                            disabled={salvandoNota}
                          >
                            Cancelar
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={salvarNotaGerencial}
                          disabled={salvandoNota || !notaForm.titulo.trim()}
                        >
                          {salvandoNota ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Salvando...
                            </>
                          ) : notaForm.id ? (
                            <>
                              <i className="fas fa-save me-2"></i>
                              Salvar Alterações
                            </>
                          ) : (
                            <>
                              <i className="fas fa-plus me-2"></i>
                              Adicionar Nota
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Helper: renderiza input de edição ou valor de visualização */}
                {(() => {
                  const d = detalhesEditaveis || {};
                  const v = detalhesEmpresa || {};

                  const campo = (coluna, label, readOnly = false) => {
                    const valor = v[coluna];
                    const renderInput = () => {
                      if (coluna === 'operador') return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          <option value="">Selecione um operador</option>
                          {operadoresUnicos.map(op=><option key={op} value={op}>{op}</option>)}
                        </select>
                      );
                      if (coluna === 'tipo_entrega') return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          <option value="">Selecione o tipo</option>
                          {['Anual','Mensal','Quarter','Semestral'].map(o=><option key={o} value={o}>{o}</option>)}
                        </select>
                      );
                      if (coluna === 'regime') return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          {['Lucro Presumido','Lucro Real','Lucro Real Trimestral','Simples Nacional','MEI','Isento'].map(o=><option key={o} value={o}>{o}</option>)}
                        </select>
                      );
                      if (coluna === 'controle_financeiro') return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          <option value="">Selecione...</option>
                          {controlesFinanceiros.map(c=><option key={c} value={c}>{c}</option>)}
                        </select>
                      );
                      if (coluna === 'dt') return (
                        <input type="number" className="form-control form-control-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)} min="1" max="31"/>
                      );
                      if (coluna === 'ultima_entrega') return (
                        <input type="month" className="form-control form-control-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}/>
                      );
                      if (coluna === 'grupo') return (
                        <div>
                          <select className="form-select form-select-sm mb-1"
                            value={gruposDisponiveis.includes(d[coluna]) ? d[coluna] : '__novo__'}
                            onChange={e=>handleDetalheChange(coluna, e.target.value==='__novo__' ? '' : e.target.value)}>
                            <option value="">Selecione o grupo</option>
                            {gruposDisponiveis.map(g=><option key={g} value={g}>{g}</option>)}
                            <option value="__novo__">Criar novo grupo...</option>
                          </select>
                          {(!d[coluna]||!gruposDisponiveis.includes(d[coluna]))&&(
                            <input type="text" className="form-control form-control-sm" placeholder="Nome do novo grupo..." value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}/>
                          )}
                        </div>
                      );
                      if (coluna === 'complexidade') return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          <option value="">Selecione...</option>
                          {['Alta','Media','Baixa'].map(o=><option key={o} value={o}>{o}</option>)}
                        </select>
                      );
                      if (coluna === 'movimentacao') return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          <option value="">Selecione...</option>
                          {['COM MOVIMENTO','SEM MOVIMENTO'].map(o=><option key={o} value={o}>{o}</option>)}
                        </select>
                      );
                      if (['bi_pago','auditoria_externa','auditoria_interna'].includes(coluna)) return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          <option value="">Selecione...</option>
                          <option value="Sim">Sim</option>
                          <option value="Não">Não</option>
                        </select>
                      );
                      if (coluna === 'tipo_bi') return (
                        <select className="form-select form-select-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}>
                          <option value="">Selecione a versão</option>
                          {['Comece Vision','Comece Vision Pro','Comece Vision Enterprise','BI Projeto'].map(o=><option key={o} value={o}>{o}</option>)}
                          {d[coluna] && !['Comece Vision','Comece Vision Pro','Comece Vision Enterprise','BI Projeto'].includes(d[coluna]) && (
                            <option value={d[coluna]}>{d[coluna]} (nome antigo)</option>
                          )}
                        </select>
                      );
                      return <input type="text" className="form-control form-control-sm" value={d[coluna] ?? ''} onChange={e=>handleDetalheChange(coluna,e.target.value)}/>;
                    };

                    const displayVal = coluna === 'ultima_entrega' && valor ? formatarCompetencia(valor) : (valor === null || valor === undefined || String(valor).trim() === '' ? '-' : valor);

                    return (
                      <div className="mb-2" key={coluna}>
                        <label className="form-label mb-1 text-muted" style={{fontSize:'0.75rem',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.04em'}}>{label}</label>
                        {modoEdicao && !readOnly
                          ? renderInput()
                          : <div className="form-control form-control-sm bg-light border-0" style={{minHeight:'31px'}}>{displayVal}{readOnly&&modoEdicao&&<span className="badge bg-secondary ms-2" style={{fontSize:'0.65rem'}}>Não editável</span>}</div>
                        }
                      </div>
                    );
                  };

                  const secao = (titulo, icone, cor, children) => (
                    <div className="card mb-3 border-0 shadow-sm">
                      <div className="card-header py-2" style={{backgroundColor: cor, color:'#fff'}}>
                        <strong style={{fontSize:'0.85rem'}}><i className={`fas fa-${icone} me-2`}></i>{titulo}</strong>
                      </div>
                      <div className="card-body py-3">
                        <div className="row g-2">{children}</div>
                      </div>
                    </div>
                  );

                  const col = (size, coluna, label, readOnly=false) => (
                    <div className={`col-md-${size}`} key={coluna}>{campo(coluna, label, readOnly)}</div>
                  );

                  return (
                    <>
                      {/* IDENTIFICAÇÃO */}
                      {secao('Identificação', 'building', '#1a3a5c', <>
                        {col(5, 'empresa',          'Empresa')}
                        {col(3, 'cnpj',             'CNPJ')}
                        {col(2, 'numero_dominio',   'Nº Domínio')}
                        {col(2, 'dt',               'DT (Dia Fechamento)')}
                        {col(3, 'operador',         'Operador')}
                        {col(3, 'regime',           'Regime Tributário')}
                        {col(3, 'grupo',            'Grupo')}
                        {col(3, 'tipo_empresa',     'Tipo de Empresa')}
                        {col(3, 'complexidade',     'Complexidade')}
                        {col(3, 'movimentacao',     'Movimentação')}
                        {col(3, 'atividade_empresa','Atividade da Empresa')}
                        {col(3, 'prioridade_cs',    'Prioridade CS')}
                      </>)}

                      {/* ENTREGA */}
                      {secao('Entrega', 'calendar-check', '#1a3a5c', <>
                        {col(2, 'tipo_entrega',        'Tipo de Entrega')}
                        {col(2, 'competencia_entrada', 'Competência Entrada')}
                        {col(2, 'competencia_saida',   'Competência Saída')}
                        {col(2, 'ultima_entrega',      'Última Entrega')}
                        {col(2, 'proxima_entrega',     'Próxima Entrega', true)}
                        {col(2, 'dias_atraso',         'Dias de Atraso',  true)}
                        {col(4, 'Status_contabil',     'Status Contábil',  true)}
                        {col(4, 'historico_entregas',  'Histórico Entregas', true)}
                      </>)}

                      {/* BI */}
                      {secao('BI', 'chart-bar', '#1a3a5c', <>
                        {col(3, 'tipo_bi',      'Comece Vision')}
                        {col(2, 'bi_pago',      'BI Pago')}
{col(3, 'link_bi',      'Link BI')}
                        {col(2, 'senha_bi',     'Senha BI')}
                      </>)}

                      {/* CONTROLE FINANCEIRO / ERP */}
                      {secao('Controle Financeiro / ERP', 'dollar-sign', '#1a3a5c', <>
                        {col(4, 'controle_financeiro', 'ERP / Controle Financeiro')}
                        {col(2, 'situacao_erp',        'Situação ERP')}
                        {col(2, 'usuario_erp',         'Usuário ERP')}
                        {col(2, 'senha_erp',           'Senha ERP')}
                        {col(2, 'link_erp',            'Link ERP')}
                        {col(3, 'auditoria_externa',   'Auditoria Externa')}
                        {col(3, 'auditoria_interna',   'Auditoria Interna')}
                        {col(3, 'dfs',                 'DFS')}
                      </>)}

                      {/* SPED */}
                      {secao('SPED', 'file-alt', '#1a3a5c', <>
                        {col(3, 'obrigatoriedade_sped',  'Obrigatoriedade SPED')}
                        {col(3, 'encerramento_sped',     'Encerramento SPED')}
                        {col(3, 'ultimo_sped_enviado',   'Último SPED Enviado')}
                        {col(3, 'obs_sped',              'Observação SPED')}
                      </>)}

                      {/* DADOS DO CLIENTE */}
                      {secao('Dados do Cliente', 'address-card', '#1a3a5c', <>
                        {col(4, 'nome_socio',      'Nome do Sócio')}
                        {col(4, 'email_socio',     'E-mail do Sócio')}
                        {col(4, 'email',           'E-mails Adicionais')}
                        {col(12, 'texto_email',     'Texto E-mail')}
                        {col(6, 'drive_cliente',   'Drive do Cliente')}
                        {col(4, 'email_operador',  'E-mail do Operador')}
                        {col(4, 'agenda_operador', 'Agenda do Operador')}
                      </>)}
                    </>
                  );
                })()}

              </div>
              <div className="modal-footer d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={() => setMostrarModalConfirmacao(true)}
                  disabled={salvandoDetalhes || inativandoCliente || modoEdicao}
                >
                  <i className="fas fa-ban me-2"></i>
                  Inativar Cliente
                </button>

                {/* Botões de ação à direita */}
                <div>
                  {modoEdicao ? (
                    <>
                      <button 
                        type="button" 
                        className="btn btn-secondary me-2" 
                        onClick={() => {
                          setModoEdicao(false);
                          setDetalhesEditaveis(detalhesEmpresa);
                        }}
                        disabled={salvandoDetalhes || inativandoCliente}
                      >
                        Cancelar
                      </button>
                      <button 
                        type="button" 
                        className="btn btn-primary"
                        onClick={salvarDetalhes}
                        disabled={salvandoDetalhes || inativandoCliente}
                      >
                        {salvandoDetalhes ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Salvando...
                          </>
                        ) : (
                          'Salvar Alterações'
                        )}
                      </button>
                    </>
                  ) : (
                    <>
                      <button 
                        type="button" 
                        className="btn btn-primary me-2" 
                        onClick={() => setModoEdicao(true)}
                        disabled={inativandoCliente}
                      >
                        <i className="fas fa-edit me-2"></i>
                        Editar
                      </button>
                      <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={() => setMostrarModalDetalhes(false)}
                        disabled={inativandoCliente}
                      >
                        Fechar
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Confirmação de Inativação */}
      {mostrarModalConfirmacao && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 10000}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-warning">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-ban me-2"></i>
                  Confirmar Inativação
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMostrarModalConfirmacao(false)}
                  disabled={inativandoCliente}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning mb-3">
                  <i className="fas fa-info-circle me-2"></i>
                  O cliente será marcado como <strong>inativo</strong> e não aparecerá mais na listagem.
                </div>

                <p className="mb-3">Confirmar inativação do cliente:</p>

                <div className="card bg-light">
                  <div className="card-body">
                    <h6 className="card-title mb-2">
                      <i className="fas fa-building me-2"></i>
                      {detalhesEmpresa?.empresa}
                    </h6>
                    <p className="card-text mb-1">
                      <small>
                        <i className="fas fa-barcode me-2"></i>
                        <strong>Nº Domínio:</strong> {detalhesEmpresa?.numero_dominio}
                      </small>
                    </p>
                    <p className="card-text mb-0">
                      <small>
                        <i className="fas fa-user me-2"></i>
                        <strong>Operador:</strong> {detalhesEmpresa?.operador || 'Não definido'}
                      </small>
                    </p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setMostrarModalConfirmacao(false)}
                  disabled={inativandoCliente}
                >
                  <i className="fas fa-times me-2"></i>
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-warning"
                  onClick={inativarCliente}
                  disabled={inativandoCliente}
                >
                  {inativandoCliente ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Inativando...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-ban me-2"></i>
                      Sim, Inativar Cliente
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DE HISTÓRICO ATUALIZADO COM STATUS_ENTREGA E BOTÃO EXPORTAR */}
      {mostrarModalHistorico && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog" style={{ maxWidth: '150vw', width: '100vw' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title mb-0 fw-bold">
                  <i className="fas fa-history me-2"></i>
                  Histórico de Entregas
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => {
                    setMostrarModalHistorico(false);
                    setFiltroHistorico('');
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {/* Barra de controles - Filtro e Exportar */}
                <div className="row mb-3">
                  <div className="col-md-9">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Filtrar por empresa, competência, domínio, tipo, operador, status ou observação..."
                      value={filtroHistorico}
                      onChange={(e) => setFiltroHistorico(e.target.value)}
                    />
                  </div>
                  <div className="col-md-3">
                    <button
                      className="btn btn-success w-100"
                      onClick={exportarHistoricoParaExcel}
                      disabled={historicoFiltrado.length === 0}
                      title={historicoFiltrado.length === 0 ? "Nenhum dado para exportar" : "Exportar para Excel"}
                    >
                      <i className="fas fa-file-excel me-2"></i>
                      Exportar Excel
                    </button>
                  </div>
                </div>

                <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                  <table className="table table-striped table-hover">
                    <thead className="table-dark sticky-top">
                      <tr>
                        <th style={{ minWidth: '130px' }}>Data/Hora</th>
                        <th style={{ minWidth: '200px' }}>Empresa</th>
                        <th style={{ minWidth: '95px' }}>Competência</th>
                        <th style={{ minWidth: '80px' }}>Nº Domínio</th>
                        <th style={{ minWidth: '100px' }}>Tipo</th>
                        <th style={{ minWidth: '95px' }}>Origem</th>
                        <th style={{ minWidth: '100px' }}>Operador</th>
                        <th style={{ minWidth: '130px' }}>Status Entrega</th>
                        <th>Observação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historicoFiltrado.length > 0 ? (
                        historicoFiltrado.map((item) => (
                          <tr key={item.id}>
                            <td style={{ minWidth: '130px', fontSize: '0.85rem' }}>{item.data_hoje}</td>
                            <td style={{ minWidth: '200px', fontSize: '0.9rem' }} className="fw-semibold">{item.empresa}</td>
                            <td style={{ minWidth: '95px', fontSize: '0.9rem' }} className="text-center">
                              <span className="badge bg-primary">{item.entregue}</span>
                            </td>
                            <td style={{ minWidth: '80px', fontSize: '0.9rem' }} className="text-center">{item.numero_dominio}</td>
                            <td style={{ minWidth: '100px', fontSize: '0.9rem' }} className="text-center">
                              <span 
                                className={`badge ${
                                  item.tipo_entrega === 'Parcial' 
                                    ? 'bg-warning text-dark' 
                                    : item.tipo_entrega === 'Atrasada'
                                    ? 'bg-danger'
                                    : item.tipo_entrega === 'Atrasada e Parcial'
                                    ? 'bg-danger text-white'
                                    : 'bg-success'
                                }`}
                              >
                                {item.tipo_entrega || 'Completa'}
                              </span>
                            </td>
                            <td style={{ minWidth: '95px', fontSize: '0.9rem' }} className="text-center">
                              {item.origem_atraso === 'INTERNO' ? (
                                <span className="badge bg-warning text-dark" title="Gargalo interno (nosso)">
                                  <i className="fas fa-building me-1"></i>Interno
                                </span>
                              ) : item.origem_atraso === 'EXTERNO' ? (
                                <span className="badge" style={{ backgroundColor: '#1e40af' }} title="Depende do cliente ou de terceiro">
                                  <i className="fas fa-user-clock me-1"></i>Externo
                                </span>
                              ) : (
                                <span className="text-muted" title="Registro anterior ao campo de origem">—</span>
                              )}
                            </td>
                            <td style={{ minWidth: '100px', fontSize: '0.9rem' }} className="text-center">
                              <span className="badge bg-info">{item.operador || 'N/A'}</span>
                            </td>
                            <td style={{ minWidth: '130px', fontSize: '0.9rem' }} className="text-center">
                              <span 
                                className={`badge ${
                                  item.status_entrega?.includes('Atrasado') 
                                    ? 'bg-danger' 
                                    : item.status_entrega?.includes('Em Dia')
                                    ? 'bg-success'
                                    : 'bg-secondary'
                                }`}
                              >
                                {item.status_entrega || 'Não informado'}
                              </span>
                            </td>
                            <td style={{ fontSize: '0.9rem', maxWidth: '260px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                              {item.texto_livre ? (
                                <div className={`${item.tipo_entrega === 'Atrasada' || item.tipo_entrega === 'Atrasada e Parcial' ? 'text-danger' : 'text-info'}`}>
                                  <i className={`fas ${item.tipo_entrega === 'Atrasada' || item.tipo_entrega === 'Atrasada e Parcial' ? 'fa-exclamation-triangle' : 'fa-comment-dots'} me-2`}></i>
                                  <span className="fst-italic">{item.texto_livre}</span>
                                  {(item.tipo_entrega === 'Atrasada' || item.tipo_entrega === 'Atrasada e Parcial') && (
                                    <small className="d-block text-muted mt-1">
                                      <i className="fas fa-clock me-1"></i>
                                      {item.tipo_entrega === 'Atrasada e Parcial' ? 'Entrega parcial com atraso' : 'Motivo do atraso'}
                                    </small>
                                  )}
                                </div>
                              ) : (
                                <span className="text-muted">
                                  <i className="fas fa-minus me-2"></i>
                                  Sem observações
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center text-muted py-4">
                            {filtroHistorico ? 'Nenhum registro encontrado com esse filtro.' : 'Nenhum histórico disponível.'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="mt-3 d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    Total de registros: <strong>{historicoFiltrado.length}</strong>
                  </small>
                  <div className="d-flex gap-3">
                    <small className="text-muted">
                      <span className="badge bg-success me-1"></span>
                      Completa
                    </small>
                    <small className="text-muted">
                      <span className="badge bg-warning text-dark me-1"></span>
                      Parcial
                    </small>
                    <small className="text-muted">
                      <span className="badge bg-danger me-1"></span>
                      Atrasada
                    </small>
                    <small className="text-muted">
                      <span className="badge bg-danger text-white me-1"></span>
                      Atrasada e Parcial
                    </small>
                  </div>
                  <small className="text-muted">
                    Últimos 1000 registros ordenados por data mais recente
                  </small>
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setMostrarModalHistorico(false);
                    setFiltroHistorico('');
                  }}
                >
                  <i className="fas fa-times me-2"></i>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Entrega */}
      {mostrarModalEntrega && empresaSelecionada && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title mb-0 fw-bold">Registrar Entrega</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setMostrarModalEntrega(false)}
                  disabled={entregaCarregando}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <p><strong>Empresa:</strong> {empresaSelecionada.empresa}</p>
                  <p><strong>Última Entrega:</strong> {formatarCompetencia(empresaSelecionada.ultima_entrega)}</p>
                  <p><strong>Próxima Entrega:</strong> {empresaSelecionada.proxima_entrega}</p>
                  <p><strong>Operador:</strong> <span className="badge bg-info">{username}</span></p>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Selecione a competência para entrega:</label>
                  <select 
                    className="form-select"
                    value={competenciaSelecionada}
                    onChange={(e) => setCompetenciaSelecionada(e.target.value)}
                    disabled={entregaCarregando}
                  >
                    {proximasCompetencias.map((comp) => (
                      <option key={comp} value={comp}>{comp}</option>
                    ))}
                  </select>
                </div>
                
                <div className="text-muted small">
                  <p>
                    Ao registrar a entrega, a data da última entrega será atualizada para a competência selecionada.
                  </p>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setMostrarModalEntrega(false)}
                  disabled={entregaCarregando}
                >
                  Cancelar
                </button>
                <div>
                  <button 
                    type="button" 
                    className="btn btn-warning me-2"
                    onClick={() => setMostrarModalEntregaParcial(true)}
                    disabled={entregaCarregando}
                  >
                    Entrega Parcial
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-primary"
                    onClick={realizarEntrega}
                    disabled={!competenciaSelecionada || entregaCarregando}
                  >
                    {entregaCarregando ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Processando...
                      </>
                    ) : (
                      'Confirmar Entrega'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Entrega Atrasada MODIFICADO COM BOTÃO PARCIAL */}
      {mostrarModalEntregaAtrasada && empresaSelecionada && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  Entrega em Atraso
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => {
                    setMostrarModalEntregaAtrasada(false);
                    setTextoEntregaAtrasada('');
                    setOrigemAtraso('');
                  }}
                  disabled={entregaCarregando}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning">
                  <i className="fas fa-exclamation-circle me-2"></i>
                  <strong>Atenção:</strong> Esta empresa está com entrega em atraso.
                </div>
                
                <div className="mb-3">
                  <p><strong>Empresa:</strong> {empresaSelecionada.empresa}</p>
                  <p><strong>Status:</strong> 
                    <span className="badge bg-danger ms-2">{empresaSelecionada.Status_contabil}</span>
                  </p>
                  <p><strong>Próxima Entrega:</strong> {empresaSelecionada.proxima_entrega}</p>
                  <p><strong>Operador:</strong> <span className="badge bg-info">{username}</span></p>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Selecione a competência para entrega:</label>
                  <select 
                    className="form-select"
                    value={competenciaSelecionada}
                    onChange={(e) => setCompetenciaSelecionada(e.target.value)}
                    disabled={entregaCarregando}
                  >
                    {proximasCompetencias.map((comp) => (
                      <option key={comp} value={comp}>{comp}</option>
                    ))}
                  </select>
                </div>
                
                <SeletorOrigemAtraso
                  valor={origemAtraso}
                  onChange={setOrigemAtraso}
                  desabilitado={entregaCarregando}
                />

                <div className="mb-3">
                  <label className="form-label">
                    <strong>Motivo do Atraso:</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <textarea 
                    className="form-control"
                    rows="4"
                    placeholder="Descreva o motivo do atraso na entrega (ex: documentos em atraso do cliente, problemas técnicos, etc.)"
                    value={textoEntregaAtrasada}
                    onChange={(e) => setTextoEntregaAtrasada(e.target.value)}
                    disabled={entregaCarregando}
                    maxLength="500"
                  />
                  <small className="text-muted">
                    {textoEntregaAtrasada.length}/500 caracteres
                  </small>
                </div>
              </div>
              <div className="modal-footer d-flex justify-content-between">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setMostrarModalEntregaAtrasada(false);
                    setTextoEntregaAtrasada('');
                    setOrigemAtraso('');
                  }}
                  disabled={entregaCarregando}
                >
                  Cancelar
                </button>
                <div>
                  {/* NOVO BOTÃO PARA ENTREGA ATRASADA PARCIAL */}
                  <button 
                    type="button" 
                    className="btn btn-info me-2"
                    onClick={() => {
                      setMostrarModalEntregaAtrasadaParcial(true);
                      setMostrarModalEntregaAtrasada(false);
                    }}
                    disabled={entregaCarregando}
                  >
                    <i className="fas fa-clock me-2"></i>
                    Entrega Parcial
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-warning"
                    onClick={realizarEntregaAtrasada}
                    disabled={!textoEntregaAtrasada.trim() || !origemAtraso || entregaCarregando}
                  >
                    {entregaCarregando ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Processando...
                      </>
                    ) : (
                      'Confirmar Entrega Completa'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* NOVO MODAL DE ENTREGA ATRASADA PARCIAL */}
      {mostrarModalEntregaAtrasadaParcial && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  Entrega Atrasada Parcial
                </h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => {
                    setMostrarModalEntregaAtrasadaParcial(false);
                    setTextoEntregaAtrasadaParcial('');
                    setOrigemAtraso('');
                  }}
                  disabled={entregaCarregando}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-warning">
                  <i className="fas fa-exclamation-circle me-2"></i>
                  <strong>Entrega Atrasada e Parcial:</strong> Esta empresa está com entrega em atraso 
                  e você está registrando apenas uma parte da entrega. Descreva o que foi entregue e o motivo do atraso.
                </div>
                
                <div className="mb-3">
                  <p><strong>Empresa:</strong> {empresaSelecionada?.empresa}</p>
                  <p><strong>Status:</strong> 
                    <span className="badge bg-danger ms-2">{empresaSelecionada?.Status_contabil}</span>
                  </p>
                  <p><strong>Competência:</strong> {competenciaSelecionada}</p>
                  <p><strong>Operador:</strong> <span className="badge bg-info">{username}</span></p>
                </div>
                
                <SeletorOrigemAtraso
                  valor={origemAtraso}
                  onChange={setOrigemAtraso}
                  desabilitado={entregaCarregando}
                />

                <div className="mb-3">
                  <label className="form-label">
                    <strong>Descrição da Entrega Parcial e Motivo do Atraso:</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <textarea 
                    className="form-control"
                    rows="5"
                    placeholder="Descreva o que foi entregue parcialmente e o motivo do atraso (ex: DRE enviada, aguardando documentos do cliente para finalização...)"
                    value={textoEntregaAtrasadaParcial}
                    onChange={(e) => setTextoEntregaAtrasadaParcial(e.target.value)}
                    disabled={entregaCarregando}
                    maxLength="500"
                  />
                  <small className="text-muted">
                    {textoEntregaAtrasadaParcial.length}/500 caracteres
                  </small>
                </div>
                
                <div className="alert alert-info">
                  <i className="fas fa-info-circle me-2"></i>
                  <strong>Importante:</strong> Esta entrega será registrada como "Atrasada e Parcial" 
                  no histórico e a empresa permanecerá com status de pendência até a entrega completa.
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => {
                    setMostrarModalEntregaAtrasadaParcial(false);
                    setTextoEntregaAtrasadaParcial('');
                    setOrigemAtraso('');
                  }}
                  disabled={entregaCarregando}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-warning"
                  onClick={realizarEntregaAtrasadaParcial}
                  disabled={!textoEntregaAtrasadaParcial.trim() || !origemAtraso || entregaCarregando}
                >
                  {entregaCarregando ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Processando...
                    </>
                  ) : (
                    'Confirmar Entrega Atrasada Parcial'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal: Último Relatório Enviado */}
      {modalRelatorioInfo && (
        <div className="modal" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 }}>
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                  <i className="fas fa-file-alt me-2"></i>
                  Último Relatório
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalRelatorioInfo(null)}
                ></button>
              </div>
              <div className="modal-body">
                <p className="fw-bold mb-2">{modalRelatorioInfo.empresa}</p>

                {/* Status atual + explicação do porquê */}
                {modalRelatorioInfo.status && (
                  <div className="mb-3">
                    <span className={`badge ${modalRelatorioInfo.status === 'Em Dia' ? 'bg-success' : 'bg-danger'} mb-2`}>
                      {modalRelatorioInfo.status === 'Em Dia'
                        ? <><i className="fas fa-check me-1"></i>Em Dia</>
                        : <><i className="fas fa-clock me-1"></i>Pendente</>}
                    </span>
                    {modalRelatorioInfo.tipoEntrega && (
                      <span className="badge bg-secondary ms-2 mb-2">
                        Entrega: {modalRelatorioInfo.tipoEntrega}
                      </span>
                    )}
                    <div
                      className="p-2 rounded"
                      style={{
                        backgroundColor: modalRelatorioInfo.status === 'Em Dia' ? '#f0fdf4' : '#fff5f5',
                        border: `1px solid ${modalRelatorioInfo.status === 'Em Dia' ? '#bbf7d0' : '#fecaca'}`,
                        fontSize: '0.82rem',
                        color: '#333'
                      }}
                    >
                      <i className="fas fa-info-circle me-1 text-muted"></i>
                      {modalRelatorioInfo.motivo}
                    </div>
                  </div>
                )}

                {modalRelatorioInfo.dataEnvio ? (
                  <>
                    <p className="mb-2">
                      <i className="fas fa-calendar-alt me-2 text-primary"></i>
                      <strong>Enviado em:</strong> {modalRelatorioInfo.dataEnvio}
                    </p>
                    <p className="mb-0">
                      <i className="fas fa-clock me-2 text-primary"></i>
                      <strong>Competência:</strong> {modalRelatorioInfo.mesAno}
                    </p>
                  </>
                ) : (
                  <p className="mb-0 text-muted">
                    <i className="fas fa-inbox me-2"></i>
                    Nenhum relatório foi enviado para esta empresa ainda.
                  </p>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setModalRelatorioInfo(null)}
                >
                  <i className="fas fa-times me-2"></i>
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de Entrega Parcial */}
      {mostrarModalEntregaParcial && (
        <div className="modal" tabIndex="-1" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title mb-0 fw-bold">Entrega Parcial</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => {
                    setMostrarModalEntregaParcial(false);
                    setTextoEntregaParcial('');
                    setOrigemAtraso('');
                  }}
                  disabled={entregaCarregando}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <p><strong>Empresa:</strong> {empresaSelecionada?.empresa}</p>
                  <p><strong>Competência:</strong> {competenciaSelecionada}</p>
                  <p><strong>Operador:</strong> <span className="badge bg-info">{username}</span></p>
                </div>

                <SeletorOrigemAtraso
                  valor={origemAtraso}
                  onChange={setOrigemAtraso}
                  desabilitado={entregaCarregando}
                  rotulo="Origem da Entrega Parcial"
                />

                <div className="mb-3">
                  <label className="form-label">
                    <strong>Observação da Entrega Parcial:</strong>
                    <span className="text-danger">*</span>
                  </label>
                  <textarea 
                    className="form-control"
                    rows="4"
                    placeholder="Descreva o que foi entregue parcialmente (ex: documentos enviados, DRE pendente, etc.)"
                    value={textoEntregaParcial}
                    onChange={(e) => setTextoEntregaParcial(e.target.value)}
                    disabled={entregaCarregando}
                    maxLength="500"
                  />
                  <small className="text-muted">
                    {textoEntregaParcial.length}/500 caracteres
                  </small>
                </div>
                
                <div className="alert alert-info">
                  <i className="fas fa-info-circle me-2"></i>
                  <strong>Atenção:</strong> A entrega parcial registrará o progresso da competência, 
                  mas manterá o status como em andamento. Descreva claramente o que foi entregue.
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-warning" 
                  onClick={() => {
                    setMostrarModalEntregaParcial(false);
                    setTextoEntregaParcial('');
                    setOrigemAtraso('');
                  }}
                  disabled={entregaCarregando}
                >
                  Cancelar
                </button>
                <button 
                  type="button" 
                  className="btn btn-warning"
                  onClick={realizarEntregaParcial}
                  disabled={!textoEntregaParcial.trim() || !origemAtraso || entregaCarregando}
                >
                  {entregaCarregando ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Processando...
                    </>
                  ) : (
                    'Confirmar Entrega Parcial'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Contabilidade;